import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';
import { BudgetImportBO } from '../budgetplan-form/budgetplan-form.model';
import { BasicAdvance, budgetBO } from '../budgetimport/budgetimport.model';
import { ADLs, AgencyDetails, AgencyDetailsBO, AgencyModel, Behaviour, CareCoordinator, Classes, ClientDetailsBO, EventBO, FMSBudget, FMSProvider, GetAgencyDetailsBO, GetClientAgencyBO, GoodsAndServices, HealthProcedures, InstrumentalActivity, Interpreter, MedicalEmergencies, NonMedicalEmergencies, ParticipantRepresentative, Providers, ServiceDeliveryPlan, serviceplanformBO, SignatureBO, WorkerBudget, WorkerTask } from './serviceplan-form.model';
import { IMyDpOptions } from 'mydatepicker';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/service/general.service';
import { ToastrService } from 'ngx-toastr';
import { CommonApiService } from 'src/app/commonapiservice';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

import { takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { ServicePlanRateBO } from '../serviceplanrate/serviceplanrate.model';
import { CommonHttpService } from 'src/app/common.service';
import { service } from 'powerbi-client';
import { FmsDataService } from '../fms-agency/fms-agencydataservice';
import { Fmsagency, getFmsagency } from '../fms-agency/fms-agency.model';
import { FmsAgencyService } from '../fms-agency/fms-agency.service';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { EventsServices } from '../events/events.service';
import { GetEventListBo } from '../events/events.modal';
import { EventsShareService } from '../events/eventsShare.service';
import { ConsultationServices } from '../consultation-services/consultation-services.service';
@Component({
  selector: 'app-serviceplan-form',
  templateUrl: './serviceplan-form.component.html',
  styleUrls: ['./serviceplan-form.component.scss']
})
export class ServiceplanFormComponent implements OnInit {
  @Input() BudgetView: any;
  @ViewChild("pdfServicePlan") pdfServicePlan;
  @ViewChild("personaccesssignaturePad") personaccesssignaturePad: SignaturePad;
  @ViewChild("parentsignaturePad1") parentsignaturePad1: SignaturePad;
  @ViewChild("providersignaturePad") providersignaturePad: SignaturePad;
  @ViewChild("AgencysignaturePad") AgencysignaturePad: SignaturePad;
  @Input() servicePlan: ServiceDeliveryPlan = new ServiceDeliveryPlan();
  @Input() serviceImprtPlan: ServiceDeliveryPlan = new ServiceDeliveryPlan();
  @Output() dataEmitFromCDCSPlan = new EventEmitter<ServiceDeliveryPlan>();
  @Output() dataEmitFromCDCSPlan1 = new EventEmitter<BasicAdvance>();
  @Output() dataTransferred = new EventEmitter<EventBO>();
  eventdata :GetEventListBo = new GetEventListBo();
  private onDestroy$: Subject<void> = new Subject<void>();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    // disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  public myDatePickerOptionsTo: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    // disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 5,
    'canvasWidth': 500,
    'canvasHeight': 200,
    'maxWidth': 5,
    'penColor': "blue"

  };
  serviceplanImportBO: ServiceDeliveryPlan = new ServiceDeliveryPlan();
  clientDetails: ClientDetailsBO = new ClientDetailsBO();
  AgencyDetails: AgencyDetailsBO = new AgencyDetailsBO();
  FMSProvider: FMSProvider = new FMSProvider();
  validform: FormGroup;
    getfmsagency : getFmsagency = new getFmsagency();
    savefmsagecy : Fmsagency = new Fmsagency();
    fmsdata:any;
    providerKeyValue :any;
    isevent : boolean = false;
    datetimeformat: object;
    GridDataEvent :any;
    languageList:any=[];
    UserDropDownList: any = [];
    StatusList:any;
    cfssModel = ['AGENCY', 'BUDGET'];
    EventList: any = [];
    sdpid : string;
    viewevent :boolean=false;
    clientConfirmation : boolean = false;
    ContactList: any = [];
      @ViewChild('gridEvents') public gridEvents: GridComponent;
    EventAlertList : any=[];
    ServiceList:any=[];
    clientname : string;
  revisionDate: string;
  isDataLoading: boolean=false;
  enableDateChangeTracking:boolean=true;;
  
  constructor(public CommonAPI: CommonApiService, private commonhttp: CommonHttpService, public datepipe: DatePipe, public router: Router, public formbuilder: FormBuilder, public dateservice: DateService, public global: GlobalComponent, 
    public general: GeneralService, public toastrService: ToastrService,  public fmsservice : FmsDataService ,public fmsagecyservice : FmsAgencyService,public EventService: EventsServices,
    private eventsShare: EventsShareService , public CSService: ConsultationServices
   ) {

    this.validform = this.formbuilder.group({
      // Personemail: ["",Validators.email],

      clientphn: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      clientzip: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      // Leademail: ["",Validators.email],
      Agencyphn: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Agencyfax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Agencyzip: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      // Fiscalemail: ["",Validators.email],
      FmsPhn: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Fmsfax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Fmszip: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      FmsEmail: ["", Validators.email],

    })
    this.CaseForm = this.formbuilder.group({
      name: [' ', Validators.required],
      street: ['',],
      state: [''],
      city: [''],
      zip: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(11)]],
      phone: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      fax: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      email: ['', [Validators.email]]
    });
  }
  Goodssubtotalcost: number = 0;
  Goodssubtotalfee: number = 0;
  Goodsgrandtotal: number = 0;
  Workergrandtotal: number = 0;
  Workertotal: number = 0;
  ptograndtotal: number = 0;
  ptototal: number = 0;
  payrollgrandtotal: number = 0;
  payrolltotal: number = 0;
  ptotaxpercent: number = 4.650;
  payrolltaxpercent: number =9.960 ;
  workertaxpercent: number = 0;
  Workercompgrandtotal: number = 0;
  Workercomptotal: number = 0;
  personwhoaccess_sign: string = "";
  personwhoaccess_signDate: string;
  paidleavepercent: number =0.440;
  parent_sign: string = "";
  parent_signDate: string;

  provider_sign: string = "";
  provider_signDate: string;
  agencystaff_sign: string = "";
  agencystaff_signDate: string;
    plwtotal: number = 0;
    paidleavegrandtotal: number = 0;
  adlsAssedneed: any = [
    {
      Key: "Eating"
    },
    {
      Key: "Grooming"
    },
    {
      Key: "Dressing"
    }, {
      Key: "Bathing"
    }, {
      Key: "Transfers"
    }, {
      Key: "Mobility"
    }, {
      Key: "Positioning"
    }, {
      Key: "Toileting"
    },
  ];
  adls_Fromwhom: any = [{ Key: "Paid worker" }, { Key: "Unpaid caregiver" }, { Key: "Combination of paid/unpaid" },{Key : "Goods and services"}]
  Iadls_Need : any = [{ Key: "Electronic communication use" }, { Key: "Light housekeeping" }, 
                      { Key: "Laundry" },{Key : "Meal preparation"} , {Key : "Personal paperwork"} , 
                      {Key : "Finances"} ,{Key : "Transportation use"} , {Key : "Shopping"}]
  goodsAndServices: GoodsAndServices[] = [];
  aDls: ADLs[] = [];
  instrumentalActivities: InstrumentalActivity[] = [];
  NonMedicalEmergencies: NonMedicalEmergencies[] = [];
  behaviours: Behaviour[] = [];
  healthProcedures: HealthProcedures[] = []
  classes: Classes[] = [];
  CaseForm: FormGroup;
  clientdob: string;
  FmsAgencyList: any = [];

  logintype: string = null;
  Budgetwarning = false;
  warningAmount ;
 changevalue: boolean = false;
 
  ngOnInit(): void {

   
    this.logintype = localStorage.getItem("CFSS_checkType");
    // this.personwhoaccess_sign = 'data:image/png;base64,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';
    setTimeout(() => {
      document.getElementById('openModal').click();
    }, 3000);
    if(this.logintype !=='onboardLogin')
    {
       this.getLanguageList();
       this.GetContactType();
       this.Getclientmodelandlanguage();
       this.GetLovDropDown();
       this.GetUserDropDownList();
       this.GetStatusLovDropDown(); 
    }
    this.getAgencyServicePlanrate();
    this.getStatesField();
    this.getFmsAgencyLov();    
    this.GetServiceType();
 
    this.datetimeformat = {
      type: "datetime",
      format: "MM/dd/yyyy h:mm:ss a",
    };
    console.log(this.servicePlan)
    if (this.servicePlan.serviceDeliveryPlanId == "00000000-0000-0000-0000-000000000000") {

      this.serviceplanImportBO.participantRepresentative = [];
      this.serviceplanImportBO.participantRepresentative.push(new ParticipantRepresentative())

      this.serviceplanImportBO.interpreters = [];
      this.serviceplanImportBO.interpreters.push(new Interpreter())


      this.serviceplanImportBO.careCoordinator = [];
      this.serviceplanImportBO.careCoordinator.push(new CareCoordinator())


      this.serviceplanImportBO.fmsBudget.workerBudgets = [];
      this.serviceplanImportBO.fmsBudget.workerBudgets.push(new WorkerBudget());

      this.serviceplanImportBO.fmsBudget.workerTasks = [];
      this.serviceplanImportBO.fmsBudget.workerTasks.push(new WorkerTask());

      this.aDls = [];
      this.aDls.push(new ADLs());

      this.instrumentalActivities = [];
      this.instrumentalActivities.push(new InstrumentalActivity());

      this.behaviours = [];
      this.behaviours.push(new Behaviour());
      this.healthProcedures = [];
      this.healthProcedures.push(new HealthProcedures());

      this.classes = [];
      this.classes.push(new Classes());

      let nonmedical: NonMedicalEmergencies[] = [
        {
          id: "00000000-0000-0000-0000-000000000000",
          situation: "Fire",
          special_Instructions: "",
          serviceDeliveryPlanId: "00000000-0000-0000-0000-000000000000"
        },
        {
          id: "00000000-0000-0000-0000-000000000000",
          situation: "Tornado",
          special_Instructions: "",
          serviceDeliveryPlanId: "00000000-0000-0000-0000-000000000000"
        },
        {
          id: "00000000-0000-0000-0000-000000000000",
          situation: "Extreme temperatures",
          special_Instructions: "",
          serviceDeliveryPlanId: "00000000-0000-0000-0000-000000000000"
        },
        {
          id: "00000000-0000-0000-0000-000000000000",
          situation: "Power outage",
          special_Instructions: "",
          serviceDeliveryPlanId: "00000000-0000-0000-0000-000000000000"
        },
        {
          id: "00000000-0000-0000-0000-000000000000",
          situation: "Flood",
          special_Instructions: "",
          serviceDeliveryPlanId: "00000000-0000-0000-0000-000000000000"
        },
      ]
      this.NonMedicalEmergencies = nonmedical;
      this.serviceplanImportBO.nonMedicalEmergencies = this.NonMedicalEmergencies;

      this.serviceplanImportBO.providers = [];
      this.serviceplanImportBO.providers.push(new Providers());
      this.serviceplanImportBO.medicalEmergencies = [];
      this.serviceplanImportBO.medicalEmergencies.push(new MedicalEmergencies());

      this.serviceplanImportBO.agencyModels.agencyDetails = [];
      this.serviceplanImportBO.agencyModels.agencyDetails.push(new AgencyDetails());
      if (this.serviceplanImportBO.modelTypename == "AGENCY") {
        this.goodsAndServices = [
          {
            id: "00000000-0000-0000-0000-000000000000",
            goods_Or_Service: "Estimated annual FMS fee",
            assessed_Need: "N/A",
            human_Support_It_Replaces: "N/A",
            cost: 0,
            fms_Fee_Percentage: null,
            fMSBudgetId: "",
            agenCyModelId: ""
          }


        ]


      }
      this.goodsAndServices.push(new GoodsAndServices());

      this.getClientDetails();
      this.getAgencyDetails();
      this.getconsultantcontactname();
      this.getFmsAgencydetail();
      this.getPR();
      this.getcasemanager();

    }
    else {
      this.getServiceDeliverPlanDetails();
      this.getFmsAgencydetail();

    }

    this.initializeRevisionTypes();
   
this.isDataLoading=true;

  }
  initializeRevisionTypes(): void {
    if (!this.serviceplanImportBO.revisionTypes) {
        this.serviceplanImportBO.revisionTypes = {
            participantRepresentative: false,
            pers: false,
            goodsAndServices: false,
            workerTraining: false,
            changingProviders: false
        };
    }
    
    if (!this.serviceplanImportBO.providerChangeTypes) {
        this.serviceplanImportBO.providerChangeTypes = {
            consultationServicesProvider: false,
            cfssProviderAgency: false,
            persProvider: false,
            fmsProvider: false
        };
    }
    
    if (!this.serviceplanImportBO.summaryOfChanges) {
        this.serviceplanImportBO.summaryOfChanges = '';
    }
    
}
  classtotal: number = null;
  Calculateclasses() {
    this.classtotal = 0;
    this.classes.forEach(e => {
      this.classtotal += (e.cost != null) ? e.cost : 0
    })
  }
  closeFun() {
    document.getElementById('openModal').click();
    this.servicePlan.edit = false;
    this.servicePlan.copy = false;
    this.global.isSDPtoEvent = false;

    this.dataEmitFromCDCSPlan.emit(this.servicePlan);

  }
  pdfenable: boolean = false;
  Download() {
  this.pdfenable = true;

  setTimeout(() => {
    this.replaceTextAreasForPDF();

    this.pdfServicePlan.A4 = true;
    this.pdfServicePlan.landscape = true;
    this.pdfServicePlan.keepTogether = ".prevent-split";
    this.pdfServicePlan.scale = 0.8;
    this.pdfServicePlan.height = 100;
    this.pdfServicePlan.margin = {
      left: "10px",
      top: "10mm",
      right: "10px",
      bottom: "10mm",
    };
    this.pdfServicePlan.padding = { bottom: "50px", top: "30px" };
    this.pdfServicePlan.forcePageBreak = ".page-header";

    this.pdfServicePlan.saveAs(
      "pdfServicePlan" +
      new Date().toLocaleDateString() +
      "-" +
      new Date().toLocaleTimeString()
    )
      setTimeout(() => {
      this.restoreTextAreasAfterPDF();
    }, 2000); // 1 second delay — adjust as needed

     this.serviceplanImportBO.clientPmi = (this.serviceplanImportBO.clientPmi != null && this.serviceplanImportBO.clientPmi != undefined && this.serviceplanImportBO.clientPmi != "") ? this.serviceplanImportBO.clientPmi : this.serviceplanImportBO.clientInfoPmi;

      this.serviceplanImportBO.plandate = this.datepipe.transform(this.serviceplanImportBO.plandate, "MM/dd/yyyy")
      this.serviceplanImportBO.startdate = this.datepipe.transform(this.serviceplanImportBO.startdate, "MM/dd/yyyy")
      this.serviceplanImportBO.enddate = (this.serviceplanImportBO.enddate != "0001-01-01T00:00:00" && this.serviceplanImportBO.enddate != undefined && this.serviceplanImportBO.enddate != "") ? this.datepipe.transform(this.serviceplanImportBO.enddate, "MM/dd/yyyy") : null;
      this.personwhoaccess_signDate = this.datepipe.transform(this.serviceplanImportBO.personSignDate, "MM/dd/yyyy")
      this.parent_signDate = this.datepipe.transform(this.serviceplanImportBO.parentalSignDate, "MM/dd/yyyy")
      this.agencystaff_signDate = this.datepipe.transform(this.serviceplanImportBO.leadSignDate, "MM/dd/yyyy")
      this.provider_signDate = this.datepipe.transform(this.serviceplanImportBO.providerSignDate, "MM/dd/yyyy")
      this.clientdob == this.datepipe.transform(this.serviceplanImportBO.personDob, "MM/dd/yyyy")


    }, 300);
}


replaceTextAreasForPDF() {
  const textareas = document.querySelectorAll('textarea');
  textareas.forEach((ta: HTMLTextAreaElement) => {
    const div = document.createElement('div');
    div.innerText = ta.value;
    div.style.border = '1px solid #ccc';
    div.style.padding = '8px';
    div.style.minHeight = '100px';
    div.style.whiteSpace = 'pre-wrap';
    div.classList.add('pdf-textarea');

    ta.style.display = 'none';
    ta.parentElement.appendChild(div);
  });
}

restoreTextAreasAfterPDF() {
  const textareas = document.querySelectorAll('textarea');
  textareas.forEach((ta: HTMLTextAreaElement) => {
    const originalValue = ta.getAttribute('data-original-value');
    const originalDisplay = ta.getAttribute('data-original-display');

    if (originalValue !== null) {
      ta.value = originalValue;
    }
    if (originalDisplay !== null) {
      ta.style.display = originalDisplay;
    } else {
      ta.style.display = 'block';
    }

    const div = ta.parentElement.querySelector('.pdf-textarea');
    if (div) {
      div.remove();
    }

    // Clean up
    ta.removeAttribute('data-original-value');
    ta.removeAttribute('data-original-display');
  });
}

  calculatePercentage(cost: number, fmsfee: number): number {
    return Number(cost * fmsfee / 100);
  }
  Fmsfee: number = 0
  AnnualTotal: number = 0
  Unusedbudget: number = 0
  mhcptotal: number = 0
  CalculateFmsFee() {
    this.Fmsfee = Number((((this.serviceplanImportBO.fmsBudget.fmsFee != null && this.serviceplanImportBO.fmsBudget.fmsFee != 0 && this.serviceplanImportBO.fmsBudget.fmsFee.toString() != "") ? this.serviceplanImportBO.fmsBudget.fmsFee : 1) * ((this.serviceplanImportBO.fmsBudget.planMonths != null && this.serviceplanImportBO.fmsBudget.planMonths != 0 && this.serviceplanImportBO.fmsBudget.planMonths.toString() != "") ? this.serviceplanImportBO.fmsBudget.planMonths : 1)).toFixed(2))
    // this.AnnualTotal = this.Goodsgrandtotal + this.Fmsfee + this.Workergrandtotal + this.mhcptotal
    // this.Unusedbudget = Math.abs(this.serviceplanImportBO.fmsBudget?.budgetAmount - this.AnnualTotal)

    this.AnnualTotal = Number((this.Goodsgrandtotal + this.Fmsfee + this.Workergrandtotal + this.mhcptotal).toFixed(2))
    this.Unusedbudget = Math.abs(Number((this.serviceplanImportBO.fmsBudget?.budgetAmount - this.AnnualTotal).toFixed(2)))
    this.cfssWorkerBudget();




  }
  stateList: any = [];
  //............................................... GetState ......................................//
  getStatesField() {
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;

    });
  }

  Calculatemhcpfee() {
    this.mhcptotal = 0;
    this.AnnualTotal = 0
    this.Unusedbudget = 0
    this.mhcptotal = Number(this.serviceplanImportBO.mhcpCost.equipment_Cost) + Number(this.serviceplanImportBO.mhcpCost.installation_Cost) + Number(this.serviceplanImportBO.mhcpCost.subscription_Cost);
    this.AnnualTotal = Number(this.Goodsgrandtotal + this.Fmsfee) + Number(this.Workergrandtotal) + Number(this.mhcptotal)
    this.Unusedbudget = Math.abs(this.serviceplanImportBO.fmsBudget.budgetAmount - this.AnnualTotal)
    this.cfssWorkerBudget();

  }
  CalculateAgentmonthlyAmt() {
    if (this.serviceplanImportBO.isFullYearPlan == true && this.serviceplanImportBO.totalCFSSUnitsEligible != null && this.serviceplanImportBO.totalCFSSUnitsEligible != 0
      && this.serviceplanImportBO.agencyModels.planSameUnitsEachMonth == true) {
      this.serviceplanImportBO.agencyModels.plannedUnits = Number((this.serviceplanImportBO.totalCFSSUnitsEligible / 12).toFixed(2))
    }
  }

  CalculateAgentmonthlyUnits() {
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.totalUnitsUsed =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJan =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsFeb =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsMar =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsApr =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsMay =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJun =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJul =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsAug =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsSep =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsOct =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsNov =0;
    // this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsDec =0;
    this.serviceplanImportBO.agencyModels.monthlyUnitUsage.totalUnitsUsed = Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsApr) + Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsAug) +
      Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsDec) + Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsFeb) + Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJan) + Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJul) + Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJun) + Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsMar) +
      Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsMay) + Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsNov) + Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsOct) + Number(this.serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsSep);


  }
  phonerr1: string[] = []
  faxerr: string[] = []
  ziperr: string[] = []
  Caseziperr: string[] = []
  CasePhnerr: string[] = []
  Casefaxerr: string[] = []

  errphone1: boolean[] = []
  errfax: boolean[] = []
  errZip: boolean[] = []

  errCaseZip: boolean[] = []
  errCasePhn: boolean[] = []
  errCasefax: boolean[] = []

  errInterpreterPhn: boolean[] = []
  InterpreterPhnerr: string[] = []

  Participantziperr: string[] = []
  ParticipantPhnerr: string[] = []

  errParticipantZip: boolean[] = []
  errparticipantPhn: boolean[] = []

  providerPhnerr: string[] = []
  errproviderPhn: boolean[] = []


  getClientDetails() {
    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_ServiceDeliveryPlan/GetClientDetails?";
      }
      else{

         url = "api/ClientAgreement/GetClientDetails?";
      }
    let param = new URLSearchParams();
    param.append("clientId", this.servicePlan.clientId);
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      let clientBO: GetClientAgencyBO = data;
      this.clientDetails = data;
      this.clientname = data?.fullName
      this.serviceplanImportBO.clientInfoFirstName = (this.serviceplanImportBO.clientInfoFirstName == null || this.serviceplanImportBO.clientInfoFirstName == "" || this.serviceplanImportBO.clientInfoFirstName == undefined) ? clientBO.firstName : this.serviceplanImportBO.clientInfoFirstName;
      this.serviceplanImportBO.clientInfoLastName = (this.serviceplanImportBO.clientInfoLastName == null || this.serviceplanImportBO.clientInfoLastName == "" || this.serviceplanImportBO.clientInfoLastName == undefined) ? clientBO.lastName : this.serviceplanImportBO.clientInfoLastName;
      this.serviceplanImportBO.clientInfoMiName = (this.serviceplanImportBO.clientInfoMiName == null || this.serviceplanImportBO.clientInfoMiName == "" || this.serviceplanImportBO.clientInfoMiName == undefined) ? clientBO.middleName : this.serviceplanImportBO.clientInfoMiName;
      this.serviceplanImportBO.clientInfoAge = (this.serviceplanImportBO.clientInfoAge == null || this.serviceplanImportBO.clientInfoAge == "" || this.serviceplanImportBO.clientInfoAge == undefined) ? clientBO.age.toString() : this.serviceplanImportBO.clientInfoAge;
      this.serviceplanImportBO.clientInfoDob = (this.serviceplanImportBO.clientInfoDob == null || this.serviceplanImportBO.clientInfoDob == "" || this.serviceplanImportBO.clientInfoDob == undefined) ? this.datepipe.transform(clientBO.dob, "MM/dd/yyyy") : this.datepipe.transform(this.serviceplanImportBO.clientInfoDob, "MM/dd/yyyy");
      this.serviceplanImportBO.clientInfoCounty = (this.serviceplanImportBO.clientInfoCounty == null || this.serviceplanImportBO.clientInfoCounty == "" || this.serviceplanImportBO.clientInfoCounty == undefined) ? clientBO.county : this.serviceplanImportBO.clientInfoCounty;
      this.serviceplanImportBO.clientInfoEmail = (this.serviceplanImportBO.clientInfoEmail == null || this.serviceplanImportBO.clientInfoEmail == "" || this.serviceplanImportBO.clientInfoEmail == undefined) ? clientBO.email : this.serviceplanImportBO.clientInfoEmail;

      this.serviceplanImportBO.clientInfoCity = (this.serviceplanImportBO.clientInfoCity == null || this.serviceplanImportBO.clientInfoCity == "" || this.serviceplanImportBO.clientInfoCity == undefined) ? clientBO.city : this.serviceplanImportBO.clientInfoCity;
      this.serviceplanImportBO.clientInfoStreet = (this.serviceplanImportBO.clientInfoStreet == null || this.serviceplanImportBO.clientInfoStreet == "" || this.serviceplanImportBO.clientInfoStreet == undefined) ? clientBO.street : this.serviceplanImportBO.clientInfoStreet;
      this.serviceplanImportBO.clientInfoState = (this.serviceplanImportBO.clientInfoState == null || this.serviceplanImportBO.clientInfoState == "" || this.serviceplanImportBO.clientInfoState == undefined) ? clientBO.state : this.serviceplanImportBO.clientInfoState;
      this.serviceplanImportBO.clientInfoZip = (this.serviceplanImportBO.clientInfoZip == null || this.serviceplanImportBO.clientInfoZip == "" || this.serviceplanImportBO.clientInfoZip == undefined) ? clientBO.zipCode : this.serviceplanImportBO.clientInfoZip;
      this.serviceplanImportBO.clientInfoPhone = (this.serviceplanImportBO.clientInfoPhone == null || this.serviceplanImportBO.clientInfoPhone == "" || this.serviceplanImportBO.clientInfoPhone == undefined) ? clientBO.phone1 || clientBO.phone2 : this.serviceplanImportBO.clientInfoPhone;

      this.clientdob = this.serviceplanImportBO.clientInfoDob
      this.serviceplanImportBO.personPmi = (this.serviceplanImportBO.personPmi == null || this.serviceplanImportBO.personPmi == "" || this.serviceplanImportBO.personPmi == undefined) ? clientBO.pmi : this.serviceplanImportBO.personPmi;
      this.serviceplanImportBO.clientInfoPmi = (this.serviceplanImportBO.clientInfoPmi == null || this.serviceplanImportBO.clientInfoPmi == "" || this.serviceplanImportBO.clientInfoPmi == undefined) ? clientBO.pmi : this.serviceplanImportBO.clientInfoPmi;
      this.serviceplanImportBO.personLastName = (this.serviceplanImportBO.personLastName == null || this.serviceplanImportBO.personLastName == "" || this.serviceplanImportBO.personLastName == undefined) ? clientBO.lastName : this.serviceplanImportBO.personLastName;

      this.serviceplanImportBO.preferrdLanguages = (this.serviceplanImportBO.preferrdLanguages == null || this.serviceplanImportBO.preferrdLanguages == "" || this.serviceplanImportBO.preferrdLanguages == undefined) ? clientBO.languages : this.serviceplanImportBO.preferrdLanguages;



      // if (this.serviceplanImportBO.id == '00000000-0000-0000-0000-000000000000') {
      //   this.serviceplanImportBO.clientPmi = this.serviceplanImportBO.clientInfoPmi

      // }

      // if(this.serviceplanImportBO.personPmi == null && this.serviceplanImportBO.personPmi ==""){
      //   this.serviceplanImportBO.personPmi = this.serviceplanImportBO.clientInfoPmi

      // }
      // this.clientDetails.pmi =;
      // if (this.clientDetails.length == 0) {
      //   this.GroupPayorService.groupPayorId = null;
      // }
    })
  }




  getServiceDeliverPlanDetails() {
    console.log("only some time called");
     this.enableDateChangeTracking = false; // 🔒 Disable before API call
    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_ServiceDeliveryPlan/GetServiceDeliveryPlan?";
      }
      else{

         url = "api/ServiceDeliveryPlan/GetServiceDeliveryPlan?";
      }
    let param = new URLSearchParams();
    param.append("serviceDeliveryPlanId", this.servicePlan.serviceDeliveryPlanId);
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      let record: ServiceDeliveryPlan = data;
      this.serviceplanImportBO = data;
      this.sdpid = this.serviceplanImportBO?.serviceDeliveryPlanId;
      this.isevent = this.serviceplanImportBO?.hasEvent;
      this.goodsAndServices = this.serviceplanImportBO.goodsAndServices
      this.aDls = this.serviceplanImportBO.adLs
      this.behaviours = this.serviceplanImportBO.behaviours
      this.healthProcedures = this.serviceplanImportBO.healthProcedures
      this.instrumentalActivities = this.serviceplanImportBO.instrumentalActivities
      this.NonMedicalEmergencies = this.serviceplanImportBO.nonMedicalEmergencies
      this.classes = this.serviceplanImportBO.classes
      this.parent_sign = this.serviceplanImportBO.parentalSignFilePath
      this.personwhoaccess_sign = this.serviceplanImportBO.personSignFilePath
      this.agencystaff_sign = this.serviceplanImportBO.leadSignFilePath
      this.provider_sign = this.serviceplanImportBO.providerSignFilePath
      this.serviceplanImportBO.clientPmi = (this.serviceplanImportBO.clientPmi != null && this.serviceplanImportBO.clientPmi != undefined && this.serviceplanImportBO.clientPmi != "") ? this.serviceplanImportBO.clientPmi : this.serviceplanImportBO.clientInfoPmi;
      this.serviceplanImportBO.clientInfoDob = this.serviceplanImportBO.clientInfoDob != null ? this.datepipe.transform(this.serviceplanImportBO.clientInfoDob, "MM/dd/yyyy") : ""
     this.revisionDate = data.revisionDate ? this.datepipe.transform(data.revisionDate, "MM/dd/yyyy") : '';
      this.serviceplanImportBO.plandate = this.datepipe.transform(this.serviceplanImportBO.plandate, "MM/dd/yyyy")
      this.serviceplanImportBO.startdate = this.datepipe.transform(this.serviceplanImportBO.startdate, "MM/dd/yyyy")
      this.serviceplanImportBO.enddate = (this.serviceplanImportBO.enddate != "0001-01-01T00:00:00" && this.serviceplanImportBO.enddate != undefined && this.serviceplanImportBO.enddate != "") ? this.datepipe.transform(this.serviceplanImportBO.enddate, "MM/dd/yyyy") : null;
      this.personwhoaccess_signDate = this.datepipe.transform(this.serviceplanImportBO.personSignDate, "MM/dd/yyyy")
      this.parent_signDate = this.datepipe.transform(this.serviceplanImportBO.parentalSignDate, "MM/dd/yyyy")
      this.agencystaff_signDate = this.datepipe.transform(this.serviceplanImportBO.leadSignDate, "MM/dd/yyyy")
      this.provider_signDate = this.datepipe.transform(this.serviceplanImportBO.providerSignDate, "MM/dd/yyyy")
      this.clientdob == this.datepipe.transform(this.serviceplanImportBO.personDob, "MM/dd/yyyy")
      this.serviceplanImportBO.clientInfoDob = this.datepipe.transform(this.serviceplanImportBO.clientInfoDob, "MM/dd/yyyy")
       this.serviceplanImportBO.revisionDate = this.datepipe.transform(this.serviceplanImportBO.revisionDate, "MM/dd/yyyy") ;
     this.serviceplanImportBO.normalRate=  (this.serviceplanImportBO.normalRate != null && this.serviceplanImportBO.normalRate!=0 && this.serviceplanImportBO.normalRate.toString()!="")? this.serviceplanImportBO.normalRate: this.planRate.normalRate;
     this.serviceplanImportBO.enhancedRate=  (this.serviceplanImportBO.enhancedRate != null && this.serviceplanImportBO.enhancedRate!=0 && this.serviceplanImportBO.enhancedRate.toString()!="")? this.serviceplanImportBO.enhancedRate: this.planRate.enhancedRate;
     this.serviceplanImportBO.ptoTax_Percent=  (this.serviceplanImportBO.ptoTax_Percent != null && this.serviceplanImportBO.ptoTax_Percent!=0 && this.serviceplanImportBO.ptoTax_Percent.toString()!="")? this.serviceplanImportBO.ptoTax_Percent: this.ptotaxpercent;
     this.serviceplanImportBO.payrollTax_Percent=  (this.serviceplanImportBO.payrollTax_Percent != null && this.serviceplanImportBO.payrollTax_Percent!=0 && this.serviceplanImportBO.payrollTax_Percent.toString()!="")? this.serviceplanImportBO.payrollTax_Percent: this.payrolltaxpercent;
     
 // Use requestAnimationFrame to ensure Angular change detection completes
      requestAnimationFrame(() => {
        this.enableDateChangeTracking = true;
        this.changevalue = false;
        console.log('Date transformations complete, tracking enabled');
      });
     this.ptotaxpercent=  this.serviceplanImportBO?.ptoTax_Percent;
     this.payrolltaxpercent=  this.serviceplanImportBO?.payrollTax_Percent;
      this.FMSProvider = this.serviceplanImportBO?.fmsProvider ?? new FMSProvider();
      this.providerKeyValue = data.fmsProvider?.providerKeyValue;      
      const isProviderPresent = this.FmsAgencyList?.some(
        agency => agency?.Key === this.providerKeyValue?.Key
    );
    if (!isProviderPresent) {
      if(this.providerKeyValue!= null || this.providerKeyValue != undefined){
      this.FmsAgencyList.push(this.providerKeyValue);
      }
  }

      this.mhcptotal = (this.serviceplanImportBO.mhcpCost.equipment_Cost != null ? this.serviceplanImportBO.mhcpCost.equipment_Cost : 0) +
        (this.serviceplanImportBO.mhcpCost.installation_Cost != null ? this.serviceplanImportBO.mhcpCost.installation_Cost : 0) + (this.serviceplanImportBO.mhcpCost.subscription_Cost != null ? this.serviceplanImportBO.mhcpCost.subscription_Cost : 0)
      if (this.serviceplanImportBO.participantRepresentative.length == 0) {
        this.serviceplanImportBO.participantRepresentative = [];
        this.serviceplanImportBO.participantRepresentative.push(new ParticipantRepresentative())

      }
      if (this.serviceplanImportBO.interpreters.length == 0) {
        this.serviceplanImportBO.interpreters = [];
        this.serviceplanImportBO.interpreters.push(new Interpreter())
      }
      if (this.serviceplanImportBO.careCoordinator.length == 0) {
        this.serviceplanImportBO.careCoordinator = [];
        this.serviceplanImportBO.careCoordinator.push(new CareCoordinator())
      }
      if (this.serviceplanImportBO.fmsBudget?.workerBudgets.length == 0) {
        this.serviceplanImportBO.fmsBudget.workerBudgets = [];
        this.serviceplanImportBO.fmsBudget.workerBudgets.push(new WorkerBudget());
      } else {
        for (let i = 0; i < this.serviceplanImportBO.fmsBudget?.workerBudgets.length; i++) {
          this.serviceplanImportBO.fmsBudget.workerBudgets[i].totalCost = 0;
          this.workertaxpercent =  this.serviceplanImportBO.fmsBudget.workerBudgets[i].percentageRate;
          setTimeout(() => {
            this.calculateWorkerbudgetAmt(i);
          }, 200);
// this.calculateWorkercompAmt();
        }

      }

      if ((this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsJan != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsJan != null) ||
        (this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsFeb != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsFeb != null) ||
        (this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsMar != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsMar != null) ||
        (this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsApr != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsApr != null) ||
        (this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsMay != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsMay != null) ||
        (this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsJun != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsJun != null) ||
        (this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsJul != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsJul != null) ||
        (this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsAug != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsAug != null) ||
        (this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsSep != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsSep != null) ||
        (this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsOct != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsOct != null) ||
        (this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsNov != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsNov != null) ||
        (this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsDec != 0 && this.serviceplanImportBO.agencyModels?.monthlyUnitUsage.unitsDec != null)) {
        this.CalculateAgentmonthlyUnits()
      }
      if (this.serviceplanImportBO.signatureBOs?.length == 0) {
        this.serviceplanImportBO.signatureBOs = [];
        this.serviceplanImportBO.signatureBOs.push(new SignatureBO());
      }

      if (this.serviceplanImportBO.fmsBudget?.workerTasks.length == 0) {
        this.serviceplanImportBO.fmsBudget.workerTasks = [];
        this.serviceplanImportBO.fmsBudget.workerTasks.push(new WorkerTask());
      }
      if (this.aDls.length == 0) {
        this.aDls = [];
        this.aDls.push(new ADLs());
      }
      if (this.instrumentalActivities.length == 0) {
        this.instrumentalActivities = [];
        this.instrumentalActivities.push(new InstrumentalActivity());
      }
      if (this.behaviours.length == 0) {
        this.behaviours = [];
        this.behaviours.push(new Behaviour());
      }

      if (this.healthProcedures.length == 0) {
        this.healthProcedures = [];
        this.healthProcedures.push(new HealthProcedures());
      }

      if (this.classes.length == 0) {
        this.classes = [];
        this.classes.push(new Classes());
      }
      else {
        this.classtotal = 0
        this.classes.forEach(ele => {
          this.classtotal += ele.cost
        })
      }

      if (this.serviceplanImportBO.providers.length == 0) {
        this.serviceplanImportBO.providers = [];
        this.serviceplanImportBO.providers.push(new Providers());
      }

      if (this.serviceplanImportBO.medicalEmergencies.length == 0) {
        this.serviceplanImportBO.medicalEmergencies = [];
        this.serviceplanImportBO.medicalEmergencies.push(new MedicalEmergencies());

      }
      if (this.serviceplanImportBO.agencyModels?.agencyDetails.length == 0) {
        this.serviceplanImportBO.agencyModels.agencyDetails = [];
        this.serviceplanImportBO.agencyModels.agencyDetails.push(new AgencyDetails());

      }
      if (this.goodsAndServices.length > 0) {
        this.Goodssubtotalcost = 0;
        this.Goodssubtotalfee = 0;
        this.Goodsgrandtotal = 0;
        this.goodsAndServices.forEach(g => {
          this.Goodssubtotalcost += Number(g.cost);
          this.Goodssubtotalfee += Number((g.fms_Fee_Percentage != null && g.fms_Fee_Percentage != 0) ? this.calculatePercentage(g.cost, g.fms_Fee_Percentage) : 0);
        })
        this.Fmsfee = this.serviceplanImportBO.fmsBudget?.fmsFee
        this.Goodsgrandtotal = this.Goodssubtotalcost + this.Goodssubtotalfee;
        this.AnnualTotal = this.Goodsgrandtotal + this.Fmsfee + this.Workergrandtotal + this.mhcptotal
        this.Unusedbudget = Math.abs(this.serviceplanImportBO.fmsBudget?.budgetAmount - this.AnnualTotal)

      }

      if (this.serviceplanImportBO.modelTypename == 'BUDGET') {
        this.CalculateFmsFee()
      }

      if (this.serviceplanImportBO.modelTypename == 'BUDGET') {
        if (this.goodsAndServices.length == 0) {
          
          this.goodsAndServices.push(new GoodsAndServices());

    
    
        }

        this.serviceplanImportBO.agencyModels = new AgencyModel(); 
         this.serviceplanImportBO.agencyModels.agencyDetails = [];
        this.serviceplanImportBO.agencyModels.agencyDetails.push(new AgencyDetails());
        console.log('agencymodel', this.serviceplanImportBO.agencyModels.agencyDetails)
      

      }
      else {

        this.serviceplanImportBO.fmsBudget = new FMSBudget();
        if (this.goodsAndServices.length == 0) {
          this.goodsAndServices = [
            {
              id: "00000000-0000-0000-0000-000000000000",
              goods_Or_Service: "Estimated annual FMS fee",
              assessed_Need: "N/A",
              human_Support_It_Replaces: "N/A",
              cost: 0,
              fms_Fee_Percentage: null,
              fMSBudgetId: "",
              agenCyModelId: ""
            }


          ]
        }

       

      }

      if (this.servicePlan.copy == true) {
        this.serviceplanImportBO.plandate = "";
        this.serviceplanImportBO.startdate = "";
        this.serviceplanImportBO.enddate = "";
        this.serviceplanImportBO.version = "";
        this.personwhoaccess_signDate = "";
        this.parent_signDate = "";
        this.agencystaff_signDate = "";
        this.provider_signDate = "";
        this.parent_sign = "";
        this.personwhoaccess_sign = "";
        this.agencystaff_sign = "";
        this.provider_sign = "";
      }
      this.cfssWorkerBudget();
      this.getAgencyDetails();
      this.getClientDetails();
      
      // this.getconsultantcontactname();
      // this.EventButtonDisable();
    }
    

      , (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
      //after all conversion enabling it 
     // this.enableDateChangeTracking=true;
  }


  getAgencyDetails() {
    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_ServiceDeliveryPlan/GetAgencyDetails?";
      }
      else{

         url = "api/ClientAgreement/GetAgencyDetails?";
      }

    let param = new URLSearchParams();
    // param.append("clientId", "");
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      let AgentBO: GetAgencyDetailsBO = data;
      this.serviceplanImportBO.consultantInfoName = (this.serviceplanImportBO.consultantInfoName == null || this.serviceplanImportBO.consultantInfoName == "" || this.serviceplanImportBO.consultantInfoName == undefined) ? AgentBO.agencyName : this.serviceplanImportBO.consultantInfoName;
      // this.AgencyDetails.npi= AgentBO.;
      this.serviceplanImportBO.consultantInfoStreet = (this.serviceplanImportBO.consultantInfoStreet == null || this.serviceplanImportBO.consultantInfoStreet == "" || this.serviceplanImportBO.consultantInfoStreet == undefined) ? AgentBO.agencyStreet : this.serviceplanImportBO.consultantInfoStreet;
      this.serviceplanImportBO.consultantInfoCity = (this.serviceplanImportBO.consultantInfoCity == null || this.serviceplanImportBO.consultantInfoCity == "" || this.serviceplanImportBO.consultantInfoCity == undefined) ? AgentBO.agencyCity : this.serviceplanImportBO.consultantInfoCity;
      this.serviceplanImportBO.consultantInfoState = (this.serviceplanImportBO.consultantInfoState == null || this.serviceplanImportBO.consultantInfoState == "" || this.serviceplanImportBO.consultantInfoState == undefined) ? AgentBO.agencyState : this.serviceplanImportBO.consultantInfoState;
      this.serviceplanImportBO.consultantInfoZip = (this.serviceplanImportBO.consultantInfoZip == null || this.serviceplanImportBO.consultantInfoZip == "" || this.serviceplanImportBO.consultantInfoZip == undefined) ? AgentBO.agencyZipCode : this.serviceplanImportBO.consultantInfoZip;
      this.serviceplanImportBO.consultantInfoState = (this.serviceplanImportBO.consultantInfoState == null || this.serviceplanImportBO.consultantInfoState == "" || this.serviceplanImportBO.consultantInfoState == undefined) ? AgentBO.agencyState : this.serviceplanImportBO.consultantInfoState;
      // this.serviceplanImportBO.consultantInfoContactName =  (this.serviceplanImportBO.consultantInfoContactName == null || this.serviceplanImportBO.consultantInfoContactName == "" || this.serviceplanImportBO.consultantInfoContactName == undefined)? AgentBO.agencyName: this.serviceplanImportBO.consultantInfoContactName ;
      // this.serviceplanImportBO.consultantInfoEmail =(this.serviceplanImportBO.consultantInfoEmail == null || this.serviceplanImportBO.consultantInfoEmail == "" || this.serviceplanImportBO.consultantInfoEmail == undefined)? AgentBO.agencyEmail: this.serviceplanImportBO.consultantInfoEmail ;
      this.serviceplanImportBO.consultantInfoFax = (this.serviceplanImportBO.consultantInfoFax == null || this.serviceplanImportBO.consultantInfoFax == "" || this.serviceplanImportBO.consultantInfoFax == undefined) ? AgentBO.agencyFax : this.serviceplanImportBO.consultantInfoFax;

      this.serviceplanImportBO.consultantInfoPhone = (this.serviceplanImportBO.consultantInfoPhone == null || this.serviceplanImportBO.consultantInfoPhone == "" || this.serviceplanImportBO.consultantInfoPhone == undefined) ? AgentBO.agencyPhone : this.serviceplanImportBO.consultantInfoPhone;
      this.serviceplanImportBO.consultantInfoPmi = (this.serviceplanImportBO.consultantInfoPmi == null || this.serviceplanImportBO.consultantInfoPmi == "" || this.serviceplanImportBO.consultantInfoPmi == undefined) ? AgentBO.agencyNpi : this.serviceplanImportBO.consultantInfoPmi;



      // this.AgencyDetails.age= ;
      // this.clientDetails. =;
      // if (this.clientDetails.length == 0) {
      //   this.GroupPayorService.groupPayorId = null;
      // }
    })
  }
  calculateGoodsandservice() {
    this.Goodssubtotalcost = 0;
    this.Goodssubtotalfee = 0;
    this.Goodsgrandtotal = 0;
    this.goodsAndServices.forEach(g => {
      this.Goodssubtotalcost += Number(g.cost);
      this.Goodssubtotalfee += Number((g.fms_Fee_Percentage != null && g.fms_Fee_Percentage != 0) ? this.calculatePercentage(g.cost, g.fms_Fee_Percentage) : 0);
    })

    this.Goodsgrandtotal = Number((this.Goodssubtotalcost + this.Goodssubtotalfee).toFixed(2));
    // this.AnnualTotal = this.Goodsgrandtotal + this.Fmsfee + this.Workergrandtotal + this.mhcptotal
    // this.Unusedbudget = Math.abs(this.serviceplanImportBO.fmsBudget?.budgetAmount - this.AnnualTotal)

    this.AnnualTotal = Number((this.Goodsgrandtotal + this.Fmsfee + this.Workergrandtotal + this.mhcptotal).toFixed(2))
    this.Unusedbudget = Math.abs(Number((this.serviceplanImportBO.fmsBudget?.budgetAmount - this.AnnualTotal).toFixed(2)))
    this.cfssWorkerBudget()



  }
  calculateBudgetAmt() {

    let budgetamt = ((this.planRate.normalRate != null && this.planRate.normalRate != 0) ? this.planRate.normalRate : 4.90);
    let Enhancebudgetamt = ((this.planRate.enhancedRate != null && this.planRate.enhancedRate != 0) ? this.planRate.enhancedRate : 5.27);
    this.serviceplanImportBO.normalRate = budgetamt;
    this.serviceplanImportBO.enhancedRate = Enhancebudgetamt;

    let num = (this.serviceplanImportBO.totalCFSSUnitsEligible * (this.serviceplanImportBO.isEnhancedrate == true ? Enhancebudgetamt : budgetamt)).toFixed(2);
    this.serviceplanImportBO.fmsBudget.budgetAmount = Number(num);
    // this.AnnualTotal = this.Goodsgrandtotal + this.Fmsfee + this.Workergrandtotal + this.mhcptotal
    // this.Unusedbudget = Math.abs(this.serviceplanImportBO.fmsBudget?.budgetAmount - this.AnnualTotal)
    this.AnnualTotal = Number((this.Goodsgrandtotal + this.Fmsfee + this.Workergrandtotal + this.mhcptotal).toFixed(2))
    this.Unusedbudget = Math.abs(Number((this.serviceplanImportBO.fmsBudget?.budgetAmount - this.AnnualTotal).toFixed(2)))
console.log(this.serviceplanImportBO.fmsBudget.budgetAmount,"this.serviceplanImportBO.fmsBudget.budgetAmount");
    this.cfssWorkerBudget();


  }

  RecalculateBudgetAmt() {

    let budgetamt = 0
    if ((this.planRate.normalRate != null && this.planRate.normalRate != 0)) {
      budgetamt = this.planRate.normalRate;
      this.serviceplanImportBO.normalRate = this.planRate.normalRate;
    }
    else {
      budgetamt = 4.90;
      this.serviceplanImportBO.normalRate = 4.90;
    }
    let Enhancebudgetamt = 0
    if ((this.planRate.enhancedRate != null && this.planRate.enhancedRate != 0)) {
      Enhancebudgetamt = this.planRate.enhancedRate;
      this.serviceplanImportBO.enhancedRate = this.planRate.enhancedRate;
    }
    else {
      Enhancebudgetamt = 4.90;
      this.serviceplanImportBO.enhancedRate = 4.90;
    }
   

    let num = (this.serviceplanImportBO.totalCFSSUnitsEligible * (this.serviceplanImportBO.isEnhancedrate == true ? Enhancebudgetamt : budgetamt)).toFixed(2);
    this.serviceplanImportBO.fmsBudget.budgetAmount = Number(num);
    this.AnnualTotal = this.Goodsgrandtotal + this.Fmsfee + this.Workergrandtotal + this.mhcptotal
    this.Unusedbudget = Math.abs(this.serviceplanImportBO.fmsBudget?.budgetAmount - this.AnnualTotal)
  
    for (let i = 0; i < this.serviceplanImportBO.fmsBudget?.workerBudgets.length; i++) {
      this.serviceplanImportBO.fmsBudget.workerBudgets[i].totalCost = 0;
      setTimeout(() => {
        this.RecalculateWorkerbudgetAmt(i);
      }, 200);

    }

  }

  calculateWorkerbudgetAmt(index) {

    this.ptograndtotal=0;
    this.payrollgrandtotal=0;
      this.Workercompgrandtotal=0;

      this.Workergrandtotal=0;
      this.paidleavegrandtotal=0; 
      
    this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost = 0
    this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost = Number((
      ((this.serviceplanImportBO.fmsBudget.workerBudgets[index].hourly_Wage != null && this.serviceplanImportBO.fmsBudget.workerBudgets[index].hourly_Wage != 0 && this.serviceplanImportBO.fmsBudget.workerBudgets[index].hourly_Wage.toString() != '') ? this.serviceplanImportBO.fmsBudget.workerBudgets[index].hourly_Wage : 1) *
      ((this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Weeks != null && this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Weeks != 0 && this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Weeks.toString() != '') ? this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Weeks : 1) *
      ((this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Hours_Per_Week != null && this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Hours_Per_Week != 0 && this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Hours_Per_Week.toString() != '') ? this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Hours_Per_Week : 1)).toFixed(2))


    // if (this.serviceplanImportBO.fmsBudget.workerBudgets[index].is_PTO_Applied) {
    //   if (this.ptotaxpercent != null && this.ptotaxpercent.toString() != "" && this.ptotaxpercent != 0) {
    //     let totalCost=Number(this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost) ;
    //     let ptoTax_Percent=Number(this.ptotaxpercent );
    //     this.serviceplanImportBO.fmsBudget.workerBudgets[index].ptototalCost = Number(((totalCost *(ptoTax_Percent / 100))).toFixed(2))
    //     this.ptograndtotal=(ptoTax_Percent / 100);
    //     this.serviceplanImportBO.ptoTax_Percent = this.ptotaxpercent;
    //   }
    // }
    // if (this.serviceplanImportBO.fmsBudget.workerBudgets[index].is_Payroll_Applied) {
    //  if (this.planRate.payrollTax_Percent != null && this.planRate.payrollTax_Percent.toString() != "" && this.planRate.payrollTax_Percent != 0) {
    //   let totalCost=Number(this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost) ;
    //   let payrollTax_Percent=Number(this.planRate.payrollTax_Percent );
    //     this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost =Number( (totalCost + (totalCost * (payrollTax_Percent / 100))).toFixed(2))
    //     this.serviceplanImportBO.payrollTax_Percent = this.planRate.payrollTax_Percent
    //   }
    // }

    // if (this.serviceplanImportBO.fmsBudget.workerBudgets[index].is_Worker_Comp_Applied && this.serviceplanImportBO.fmsBudget.workerBudgets[index].percentageRate != null && this.serviceplanImportBO.fmsBudget.workerBudgets[index].percentageRate != 0) {
   
    //   let totalCost=Number(this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost) ;
    //   let percentageRate=Number(this.serviceplanImportBO.fmsBudget.workerBudgets[index].percentageRate);
     
    //   this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost = Number((totalCost +( totalCost *( percentageRate / 100))).toFixed(2))

      
    // }
  
    this.ptototal = 0;
    this.payrolltotal = 0;
    this.Workercomptotal = 0;
    this.plwtotal = 0;
    console.log(this.ptototal);
    console.log(this.ptotaxpercent,"ptotaxpercent");
    
    
    this.serviceplanImportBO.fmsBudget.workerBudgets.forEach(e => {

      if (e.is_PTO_Applied) {
        if (this.ptotaxpercent != null && this.ptotaxpercent.toString() != "" && this.ptotaxpercent != 0) {
          let totalCost=Number(e.totalCost) ;
          let ptoTax_Percent=Number(this.ptotaxpercent );
          console.log(this.ptograndtotal,"(this.ptograndtotal");
          console.log(this.ptototal,"(this.ptototal");
          console.log(e.totalCost,"(this.e.totalCost");
          let grandtotal= Number(this.ptograndtotal)
          
          this.ptograndtotal = Number((grandtotal+(totalCost *(ptoTax_Percent / 100))).toFixed(2))
          this.ptototal= Number((this.ptototal + totalCost).toFixed(2));
          this.serviceplanImportBO.ptoTax_Percent = this.ptotaxpercent;
        }
      }

       if (e.is_Payroll_Applied) {
        if (this.payrolltaxpercent != null && this.payrolltaxpercent.toString() != "" && this.payrolltaxpercent != 0) {
         let totalCost=Number(e.totalCost) ;
         let payrollTax_Percent=Number(this.payrolltaxpercent );
          this.payrollgrandtotal =Number( (this.payrollgrandtotal + (totalCost * (payrollTax_Percent / 100))).toFixed(2))
          
          this.payrolltotal= Number((this.payrolltotal + e.totalCost).toFixed(2));
       
          this.serviceplanImportBO.payrollTax_Percent = this.payrolltaxpercent
         }

         if (this.paidleavepercent != null && this.paidleavepercent.toString() != "" && this.paidleavepercent != 0) {
         let totalCost=Number(e.totalCost) ;
         let PaidLeave_Percent=Number(this.paidleavepercent );
          this.paidleavegrandtotal =Number( (this.paidleavegrandtotal + (totalCost * (PaidLeave_Percent / 100))).toFixed(2))
          
          this.plwtotal= Number((this.plwtotal + e.totalCost).toFixed(2));
       
          this.serviceplanImportBO.PaidLeave_Percent = this.paidleavepercent
         }
       }


       if (e.is_Worker_Comp_Applied ) {
        let totalCost=Number(e.totalCost) ;
         let percentageRate=Number(this.workertaxpercent);
          
        e.percentageRate= percentageRate;
          this.Workercomptotal= Number((this.Workercomptotal + e.totalCost).toFixed(2));
         
       }

       if (e.is_Worker_Comp_Applied &&this.workertaxpercent != null && this.workertaxpercent != 0) {
        let totalCost=Number(e.totalCost) ;
         let percentageRate=Number(this.workertaxpercent);
          
        e.percentageRate= percentageRate;
       //  e.totalCost = Number((totalCost +( totalCost *( percentageRate / 100))).toFixed(2))
         this.Workercompgrandtotal =Number( (this.Workercompgrandtotal + (totalCost * (percentageRate / 100))).toFixed(2))
       //  this.Workercomptotal= Number((this.Workercomptotal + e.totalCost).toFixed(2));
        
         console.log( this.Workercompgrandtotal ," this.Workercompgrandtotal =-====================");
         
       }
     
      this.Workergrandtotal = Number(( this.Workergrandtotal+ e.totalCost ).toFixed(2))
      
    
     
    })
    this.Workergrandtotal = Number((this.Workergrandtotal + this.ptograndtotal+ this.payrollgrandtotal+ this.Workercompgrandtotal + this.paidleavegrandtotal).toFixed(2))
    this.AnnualTotal = Number((this.Goodsgrandtotal + this.Fmsfee + this.Workergrandtotal + this.mhcptotal).toFixed(2))
    this.Unusedbudget = Math.abs(Number((this.serviceplanImportBO.fmsBudget?.budgetAmount - this.AnnualTotal).toFixed(2)))
    if(this.AnnualTotal > this.serviceplanImportBO.cfssWorkerBudget)
    {
      this.Budgetwarning = true;
      this.warningAmount = Number(this.AnnualTotal- this.serviceplanImportBO.cfssWorkerBudget).toFixed(2);
    }
    else
      this.Budgetwarning = false;


  }


  calculateWorkercompAmt() {

     this.Workercompgrandtotal=0;
      
   
     this.ptograndtotal=0;
     this.payrollgrandtotal=0;
     this.ptototal = 0;
     this.payrolltotal = 0;
    this.Workergrandtotal = 0;
  
    this.Workercomptotal = 0;
    this.serviceplanImportBO.fmsBudget.workerBudgets.forEach(e => {

    
      if (e.is_PTO_Applied) {
        if (this.ptotaxpercent != null && this.ptotaxpercent.toString() != "" && this.ptotaxpercent != 0) {
          let totalCost=Number(e.totalCost) ;
          let ptoTax_Percent=Number(this.ptotaxpercent );
          console.log(this.ptograndtotal,"(this.ptograndtotal");
          console.log(this.ptototal,"(this.ptototal");
          console.log(e.totalCost,"(this.e.totalCost");
          let grandtotal= Number(this.ptograndtotal)
          
          this.ptograndtotal = Number((grandtotal+(totalCost *(ptoTax_Percent / 100))).toFixed(2))
          this.ptototal= Number((this.ptototal + totalCost).toFixed(2));
          this.serviceplanImportBO.ptoTax_Percent =Number( this.ptotaxpercent);
        }
      }

      if (e.is_Payroll_Applied) {
        if (this.payrolltaxpercent != null && this.payrolltaxpercent.toString() != "" && this.payrolltaxpercent != 0) {
         let totalCost=Number(e.totalCost) ;
         let payrollTax_Percent=Number(this.payrolltaxpercent );
          this.payrollgrandtotal =Number( (this.payrollgrandtotal + (totalCost * (payrollTax_Percent / 100))).toFixed(2))
          
          this.payrolltotal= Number((this.payrolltotal + e.totalCost).toFixed(2));
       
          this.serviceplanImportBO.payrollTax_Percent = this.payrolltaxpercent
         }
         if (this.paidleavepercent != null && this.paidleavepercent.toString() != "" && this.paidleavepercent != 0) {
         let totalCost=Number(e.totalCost) ;
         let PaidLeave_Percent=Number(this.paidleavepercent );
          this.paidleavegrandtotal =Number( (this.paidleavegrandtotal + (totalCost * (PaidLeave_Percent / 100))).toFixed(2))
          
          this.plwtotal= Number((this.plwtotal + e.totalCost).toFixed(2));
       
          this.serviceplanImportBO.PaidLeave_Percent = this.paidleavepercent
         }
       }


    


       if (e.is_Worker_Comp_Applied &&this.workertaxpercent != null && this.workertaxpercent != 0) {
       let totalCost=Number(e.totalCost) ;
        let percentageRate=Number(this.workertaxpercent);
         
       e.percentageRate= percentageRate;
      //  e.totalCost = Number((totalCost +( totalCost *( percentageRate / 100))).toFixed(2))
        this.Workercompgrandtotal =Number( (this.Workercompgrandtotal + (totalCost * (percentageRate / 100))).toFixed(2))
        this.Workercomptotal= Number((this.Workercomptotal + e.totalCost).toFixed(2));
       
        console.log( this.Workercompgrandtotal ," this.Workercompgrandtotal =-====================");
        
      }
      
      this.Workergrandtotal = Number(( this.Workergrandtotal+ e.totalCost).toFixed(2))
      
    })

    this.Workergrandtotal = Number((this.Workergrandtotal + this.ptograndtotal+ this.payrollgrandtotal+ this.Workercompgrandtotal).toFixed(2))
   
    this.AnnualTotal = Number((this.Goodsgrandtotal + this.Fmsfee + this.Workergrandtotal + this.mhcptotal).toFixed(2))
    this.Unusedbudget = Math.abs(Number((this.serviceplanImportBO.fmsBudget?.budgetAmount - this.AnnualTotal).toFixed(2)))

  }
  RecalculateWorkerbudgetAmt(index) {

    let ptotax = this.planRate.ptoTax_Percent;
    let payrolltax = this.planRate.payrollTax_Percent;
    this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost = 0
    this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost = this.serviceplanImportBO.fmsBudget.workerBudgets[index].hourly_Wage *
      ((this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Weeks != null && this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Weeks != 0) ? this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Weeks : 1) *
      ((this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Hours_Per_Week != null && this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Hours_Per_Week != 0) ? this.serviceplanImportBO.fmsBudget.workerBudgets[index].no_Of_Hours_Per_Week : 1)
    if (this.serviceplanImportBO.fmsBudget.workerBudgets[index].is_PTO_Applied) {
      if (this.planRate.ptoTax_Percent != null && this.planRate.ptoTax_Percent.toString() != "" && this.planRate.ptoTax_Percent != 0) {
        this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost = Number(this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost) + (Number(this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost) * Number(this.planRate.ptoTax_Percent / 100))
        this.serviceplanImportBO.ptoTax_Percent = this.planRate.ptoTax_Percent;
      }
    }
    if (this.serviceplanImportBO.fmsBudget.workerBudgets[index].is_PTO_Applied) {
      if (this.planRate.payrollTax_Percent != null && this.planRate.payrollTax_Percent.toString() != "" && this.planRate.payrollTax_Percent != 0) {
        this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost = Number(this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost) + (Number(this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost) * Number(this.planRate.payrollTax_Percent / 100))
        this.serviceplanImportBO.payrollTax_Percent = this.planRate.payrollTax_Percent
      }
    }

    if (this.serviceplanImportBO.fmsBudget.workerBudgets[index].is_Worker_Comp_Applied && this.serviceplanImportBO.fmsBudget.workerBudgets[index].percentageRate != null && this.serviceplanImportBO.fmsBudget.workerBudgets[index].percentageRate != 0) {
      this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost = Number(this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost) + (Number(this.serviceplanImportBO.fmsBudget.workerBudgets[index].totalCost) * Number(this.serviceplanImportBO.fmsBudget.workerBudgets[index].percentageRate / 100))
    }
    this.Workergrandtotal = 0;
    this.serviceplanImportBO.fmsBudget.workerBudgets.forEach(e => {
      this.Workergrandtotal += e.totalCost
    })
    this.AnnualTotal = Number((this.Goodsgrandtotal + this.Fmsfee + this.Workergrandtotal + this.mhcptotal).toFixed(2))
    this.Unusedbudget = Math.abs(Number((this.serviceplanImportBO.fmsBudget?.budgetAmount - this.AnnualTotal).toFixed(2)))


  }
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  NumbersOnly(event: any) {
    const pattern = /^[0-9]*\.?[0-9]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  DemographicPhoneFormat(value) {
    if (value == 'phone') {
      this.serviceplanImportBO.clientInfoPhone = this.general.converPhoneGoogleLib(this.serviceplanImportBO.clientInfoPhone);
    }
    if (value == 'agencyphone') {
      this.serviceplanImportBO.consultantInfoPhone = this.general.converPhoneGoogleLib(this.serviceplanImportBO.consultantInfoPhone);
    }
    if (value == 'agencyfax') {
      this.serviceplanImportBO.consultantInfoFax = this.general.converPhoneGoogleLib(this.serviceplanImportBO.consultantInfoFax);
    }

    if (value == 'fmsproviderphone') {
      this.FMSProvider.phoneNumber = this.general.converPhoneGoogleLib(this.FMSProvider.phoneNumber);
    }
    if (value == 'fmsproviderfax') {
      this.FMSProvider.fax = this.general.converPhoneGoogleLib(this.FMSProvider.fax);
    }

  }

  ModelTypeChange() {
    // this.aDls = [];
    // this.aDls.push(new ADLs());

    // this.instrumentalActivities = [];
    // this.instrumentalActivities.push(new InstrumentalActivity());

    // this.behaviours = [];
    // this.behaviours.push(new Behaviour());
    // this.healthProcedures = [];
    // this.healthProcedures.push(new HealthProcedures());

    // this.classes = [];
    // this.classes.push(new Classes());
    this.goodsAndServices=[];

    this.Goodssubtotalcost= 0;
    this.Goodssubtotalfee = 0;
    this.Goodsgrandtotal = 0;
    this.Workergrandtotal = 0;
    this.payrollgrandtotal = 0;
    this.ptograndtotal = 0;
    this.Workercompgrandtotal = 0;
    this.ptototal = 0;
    this.payrolltotal = 0;
    this.Workercomptotal = 0;

    this.serviceplanImportBO.agencyModels=  new AgencyModel(); 
    let list = new AgencyDetails();
    this.serviceplanImportBO.agencyModels.agencyDetails.push(list);
    this.calculateBudgetAmt();
    let budgetamt = this.serviceplanImportBO.fmsBudget.budgetAmount;
    this.serviceplanImportBO.fmsBudget= new FMSBudget();
    this.serviceplanImportBO.is_Goods_And_Service = null
    
    if (this.serviceplanImportBO.modelTypename == "AGENCY") {
      this.goodsAndServices = [
        {
          id: "00000000-0000-0000-0000-000000000000",
          goods_Or_Service: "Estimated annual FMS fee",
          assessed_Need: "N/A",
          human_Support_It_Replaces: "N/A",
          cost: 0,
          fms_Fee_Percentage: null,
          fMSBudgetId: "",
          agenCyModelId: ""
        }


      ]


    }else{
      this.serviceplanImportBO.fmsBudget.budgetAmount=budgetamt
      this.goodsAndServices.push(new GoodsAndServices());

      this.serviceplanImportBO.fmsBudget.workerBudgets = [];
      this.serviceplanImportBO.fmsBudget.workerBudgets.push(new WorkerBudget());

      this.serviceplanImportBO.fmsBudget.workerTasks = [];
      this.serviceplanImportBO.fmsBudget.workerTasks.push(new WorkerTask());
      this.serviceplanImportBO.isRedirectionRequired = null

      this.behaviours = [];
      this.behaviours.push(new Behaviour());
      this.serviceplanImportBO.isHealthProceduresRequired= null

        this.healthProcedures = [];
    this.healthProcedures.push(new HealthProcedures());

    this.serviceplanImportBO.isMedicationsRequired=null;
    this.serviceplanImportBO.bringMedications=null;
    this.serviceplanImportBO.bringMedicationItems= null;
    this.serviceplanImportBO.other= null;
    this.serviceplanImportBO.otherDetails=null
    this.serviceplanImportBO.medicationInstructionsDetails = null
    this.serviceplanImportBO.medicationTimeReminders= null
    this.serviceplanImportBO.isSkillEnhancement_Included= null;
    this.serviceplanImportBO.maintenancePlan= null
     this.classes = [];
    this.classes.push(new Classes());
    this.classtotal= 0;
    }

 
  }
  DemographicPhoneFormatParticipant(value, index) {
    this.serviceplanImportBO.participantRepresentative[index].phoneNumber = this.general.converPhoneGoogleLib(this.serviceplanImportBO.participantRepresentative[index].phoneNumber);
  }
  DemographicPhoneFormatInterpreter(value, index) {
    this.serviceplanImportBO.interpreters[index].phonenumer = this.general.converPhoneGoogleLib(this.serviceplanImportBO.interpreters[index].phonenumer);
  }

  DemographicPhoneFormatProvider(value, index) {
    this.serviceplanImportBO.providers[index].phoneNumber = this.general.converPhoneGoogleLib(this.serviceplanImportBO.providers[index].phoneNumber);
  }
  DemographicPhoneFormatcasemanager(value, index, type) {
    if (type == 'phone') {
      this.serviceplanImportBO.careCoordinator[index].phoneNumber = this.general.converPhoneGoogleLib(this.serviceplanImportBO.careCoordinator[index].phoneNumber);
    }
    if (type == 'fax') {
      this.serviceplanImportBO.careCoordinator[index].fax = this.general.converPhoneGoogleLib(this.serviceplanImportBO.careCoordinator[index].fax);
    }


  }

  DemographicPhoneFormatagencymodel(value, index, type) {
    if (type == 'phone') {
      this.serviceplanImportBO.agencyModels.agencyDetails[index].phoneNumber = this.general.converPhoneGoogleLib(this.serviceplanImportBO.agencyModels.agencyDetails[index].phoneNumber);
    }
    if (type == 'fax') {
      this.serviceplanImportBO.agencyModels.agencyDetails[index].faxNumber = this.general.converPhoneGoogleLib(this.serviceplanImportBO.agencyModels.agencyDetails[index].faxNumber);
    }


  }
  DemographicPhoneFormat_4(value) {
    if (value == 'phone') {
      // this.support.phone = this.general.converPhoneGoogleLib(this.Case.phone);
    }
    if (value == 'fax') {
      // this.support.fax = this.general.converPhoneGoogleLib(this.Case.fax);
    }
  }

  newdates(event, type, name) {
     if (!this.enableDateChangeTracking) {
      return;
    }
    if (type == "inputchage") {
      if (name == 'plandate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.serviceplanImportBO.plandate = val1;
          this.changefunction();

        }
      }

      if (name == 'startdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.serviceplanImportBO.startdate = val1;
          this.EventButtonDisable();
          this.changefunction();
        }
      }
      if (name == 'enddate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.serviceplanImportBO.enddate = val1;
          this.EventButtonDisable();
          this.changefunction();
        }
      }
      if (name == 'personwhoaccess_signDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined && val != "" && val != null) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.serviceplanImportBO.personSignDate = val1;
          this.personwhoaccess_signDate = val1;
          this.changefunction();
        }
      }
      if (name == 'parent_signDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined && val != "" && val != null) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.serviceplanImportBO.parentalSignDate = val1;
          this.parent_signDate = val1;
          this.changefunction();
        }
      }

      if (name == 'provider_signDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined && val != "" && val != null) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.serviceplanImportBO.providerSignDate = val1;
          this.provider_signDate = val1;
          this.changefunction();
        }
      }
      if (name == 'agencystaff_signDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined && val != "" && val != null) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.serviceplanImportBO.leadSignDate = val1;
          this.agencystaff_signDate = val1;
          this.changefunction();
        }
      }
      if (name == 'personDob') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.clientdob = val1
          this.serviceplanImportBO.personDob = val1;
          this.changefunction();
        }
      }

     if (name == 'dob') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.serviceplanImportBO.clientInfoDob = val1;
          this.changefunction();

        }
      }
      if (name == 'revisionDate') {
            let val = this.dateservice.inputFeildchange(event);
            if (val != undefined) {
                let val1 = this.dateservice.inputFeildchange(event);
                this.revisionDate = val1;
                this.serviceplanImportBO.revisionDate = val1;
                this.changefunction();
            }
          }


    }






    if (type == "datechagned") {
      if (name == 'startdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.serviceplanImportBO.startdate = val1;
          this.EventButtonDisable();
          this.changefunction();
        }
      }

      if (name == 'enddate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.serviceplanImportBO.enddate = val1;
          this.EventButtonDisable();
          this.changefunction();
        }
      }
      if (name == 'plandate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.serviceplanImportBO.plandate = val1;
          this.EventButtonDisable();
          this.changefunction();
        }
      }
      if (name == 'personwhoaccess_signDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined && val != "" && val != null) {
          let val1 = this.dateservice.Datechange(event);
          this.serviceplanImportBO.personSignDate = val1;
          this.personwhoaccess_signDate = val1;
          this.changefunction();
        }
      }
      if (name == 'parent_signDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined && val != "" && val != null) {
          let val1 = this.dateservice.Datechange(event);
          this.serviceplanImportBO.parentalSignDate = val1;
          this.parent_signDate = val1;
          this.changefunction();
        }
      }
      if (name == 'provider_signDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined && val != "" && val != null) {
          let val1 = this.dateservice.Datechange(event);
          this.serviceplanImportBO.providerSignDate = val1;
          this.provider_signDate = val1;
          this.changefunction();
        }
      }

      if (name == 'agencystaff_signDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.serviceplanImportBO.leadSignDate = val1;
          this.agencystaff_signDate = val1;
          this.changefunction();
        }
      }

      if (name == 'personDob') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.clientdob = val1
          this.serviceplanImportBO.personDob = val1;
          this.changefunction();
        }
      }
      if (name == 'dob') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.clientdob = val1
          this.serviceplanImportBO.clientInfoDob = val1;
          this.changefunction();
        }
      }
      if (name == 'revisionDate') {
            let val = this.dateservice.Datechange(event);
            if (val != undefined) {
                let val1 = this.dateservice.Datechange(event);
                this.revisionDate = val1;
                this.serviceplanImportBO.revisionDate = val1;
                this.changefunction();
            }
          }

    }
    console.log(this.serviceplanImportBO);
  }


  parentColumn1: boolean = false;

  Createparent(i) {
    if (this.serviceplanImportBO.participantRepresentative.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new ParticipantRepresentative();
    this.serviceplanImportBO.participantRepresentative.push(list);

  }

  removeparent(Contact, BO) {
   

      if (BO.id == '00000000-0000-0000-0000-000000000000') {
        // this.serviceplanImportBO.participantRepresentative.splice(Contact, 1);
        const index = this.serviceplanImportBO.participantRepresentative.findIndex(item => item === BO);
  
        if (index !== -1) {
          this.serviceplanImportBO.participantRepresentative.splice(index, 1);
        }
  
      } else {
  
        const index = this.serviceplanImportBO.participantRepresentative.findIndex(item => item === BO);
  
        if (index !== -1) {
          this.serviceplanImportBO.participantRepresentative.splice(index, 1);
        }
  
        // this.serviceplanImportBO.participantRepresentative.splice(Contact, 1);
        if (this.servicePlan.serviceDeliveryPlanId != "00000000-0000-0000-0000-000000000000")
          {
        let url = "api/ServiceDeliveryPlan/DeleteParticipant?";
        let params = new URLSearchParams();
        params.append("participantRepresentativeId", BO.id);
        this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.toastrService.success("Deleted successfully!")
  
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
  
        }, (err: any) => {
          this.toastrService.error(err, 'Error'), 8000;
        });
      }
  
  
  
      // if(this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty.length==1){
      //   this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty[0].isadd=false
      // }
    }
  }


  Createinterpreter(i) {
    if (this.serviceplanImportBO.interpreters.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new Interpreter();
    this.serviceplanImportBO.interpreters.push(list);

  }

  removeinterpreter(interpreters, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      const index = this.serviceplanImportBO.interpreters.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.interpreters.splice(index, 1);
      }

    } else {
      const index = this.serviceplanImportBO.interpreters.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.interpreters.splice(index, 1);
      }
      let url = "api/ServiceDeliveryPlan/DeleteInterpreter?";
      let params = new URLSearchParams();
      params.append("InterpreterId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }



    // if(this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty.length==1){
    //   this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty[0].isadd=false
    // }
  }


  Createcarecoordinator(i) {
    if (this.serviceplanImportBO.careCoordinator.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new CareCoordinator();
    this.serviceplanImportBO.careCoordinator.push(list);

  }


  removecarecoordinatoe(careCoordinator, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000' ) {

      const index = this.serviceplanImportBO.careCoordinator.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.careCoordinator.splice(index, 1);
      }

    } else {
      const index = this.serviceplanImportBO.careCoordinator.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.careCoordinator.splice(index, 1);
      }
      let url = "api/ServiceDeliveryPlan/DeletecareCoordinator?";
      let params = new URLSearchParams();
      params.append("careCoortinatorId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }



    // if(this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty.length==1){
    //   this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty[0].isadd=false
    // }
  }


  Createagencymodel(i) {
    if (this.serviceplanImportBO.agencyModels.agencyDetails.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new AgencyDetails();
    this.serviceplanImportBO.agencyModels.agencyDetails.push(list);

  }

  removeagencymodel(model, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {

      const index = this.serviceplanImportBO.agencyModels.agencyDetails.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.agencyModels.agencyDetails.splice(index, 1);
      }

    } else {
      const index = this.serviceplanImportBO.agencyModels.agencyDetails.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.agencyModels.agencyDetails.splice(index, 1);
      }

      let url = "api/ServiceDeliveryPlan/DeleteAgencyDetail?";
      let params = new URLSearchParams();
      params.append("agencyDetailId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }



    // if(this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty.length==1){
    //   this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty[0].isadd=false
    // }
  }

  Creategoods() {
    if (this.goodsAndServices.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new GoodsAndServices();
    this.goodsAndServices.push(list);

  }

  removegoods(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      this.goodsAndServices.splice(Contact, 1);
      const index = this.goodsAndServices.findIndex(item => item === BO);

      if (index !== -1) {
        this.goodsAndServices.splice(index, 1);
      }


    } else {
      const index = this.goodsAndServices.findIndex(item => item === BO);

      if (index !== -1) {
        this.goodsAndServices.splice(index, 1);
      }
      let url = "api/ServiceDeliveryPlan/DeleteGoodsAndServices?";
      let params = new URLSearchParams();
      params.append("goodsId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }


  }

  Createworker() {
    if (this.serviceplanImportBO.fmsBudget.workerBudgets.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new WorkerBudget();
    this.serviceplanImportBO.fmsBudget.workerBudgets.push(list);

  }

  removeworker(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      const index = this.serviceplanImportBO.fmsBudget.workerBudgets.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.fmsBudget.workerBudgets.splice(index, 1);
      }
      this.Workergrandtotal = 0
      this.serviceplanImportBO.fmsBudget.workerBudgets.forEach(e => {
        this.Workergrandtotal += (e.totalCost != null && e.totalCost.toString() != "") ? e.totalCost : 0
      })

    } else {
      this.Workergrandtotal = 0
      this.serviceplanImportBO.fmsBudget.workerBudgets.forEach(e => {
        this.Workergrandtotal += (e.totalCost != null && e.totalCost.toString() != "") ? e.totalCost : 0
      })
      const index = this.serviceplanImportBO.fmsBudget.workerBudgets.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.fmsBudget.workerBudgets.splice(index, 1);
      }
      let url = "api/ServiceDeliveryPlan/DeleteWorkerBudget?";
      let params = new URLSearchParams();
      params.append("classId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }


  }

  Createworkertask() {
    if (this.serviceplanImportBO.fmsBudget.workerTasks.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new WorkerTask();
    this.serviceplanImportBO.fmsBudget.workerTasks.push(list);

  }

  removeworkertask(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {

      const index = this.serviceplanImportBO.fmsBudget.workerTasks.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.fmsBudget.workerTasks.splice(index, 1);
      }

    } else {
      const index = this.serviceplanImportBO.fmsBudget.workerTasks.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.fmsBudget.workerTasks.splice(index, 1);
      }
      let url = "api/ServiceDeliveryPlan/DeleteWorkerTasks?";
      let params = new URLSearchParams();
      params.append("classId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }



  }

  Createadls() {
    if (this.aDls.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new ADLs();
    this.aDls.push(list);

  }

  removeadls(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      const index = this.aDls.findIndex(item => item === BO);

      if (index !== -1) {
        this.aDls.splice(index, 1);
      }

    } else {
      const index = this.aDls.findIndex(item => item === BO);

      if (index !== -1) {
        this.aDls.splice(index, 1);
      }
      let url = "api/ServiceDeliveryPlan/DeleteADL?";
      let params = new URLSearchParams();
      params.append("aDLId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }


  }


  CreateIadls() {
    if (this.instrumentalActivities.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new InstrumentalActivity();
    this.instrumentalActivities.push(list);

  }

  removeIadls(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      const index = this.instrumentalActivities.findIndex(item => item === BO);

      if (index !== -1) {
        this.instrumentalActivities.splice(index, 1);
      }

    } else {
      const index = this.instrumentalActivities.findIndex(item => item === BO);

      if (index !== -1) {
        this.instrumentalActivities.splice(index, 1);
      }
      let url = "api/ServiceDeliveryPlan/DeleteIADL?";
      let params = new URLSearchParams();
      params.append("iADLId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }


  }


  Createbehaviour() {
    if (this.behaviours.length > 0) {
      this.parentColumn1 = true;

    }

    let list = new Behaviour();
    this.behaviours.push(list);

  }

  removebehaviour(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      const index = this.behaviours.findIndex(item => item === BO);

      if (index !== -1) {
        this.behaviours.splice(index, 1);
      }

    } else {
      const index = this.behaviours.findIndex(item => item === BO);

      if (index !== -1) {
        this.behaviours.splice(index, 1);
      }
      let url = "api/ServiceDeliveryPlan/DeleteBehaviours?";
      let params = new URLSearchParams();
      params.append("behaviourId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }


  }


  CreatehealthProcedures() {
    if (this.healthProcedures.length > 0) {
      this.parentColumn1 = true;

    }

    let list = new HealthProcedures();
    this.healthProcedures.push(list);

  }

  removehealthProcedures(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      const index = this.healthProcedures.findIndex(item => item === BO);

      if (index !== -1) {
        this.healthProcedures.splice(index, 1);
      }

    } else {
      const index = this.healthProcedures.findIndex(item => item === BO);

      if (index !== -1) {
        this.healthProcedures.splice(index, 1);
      }
      let url = "api/ServiceDeliveryPlan/DeleteHealthProcedure?";
      let params = new URLSearchParams();
      params.append("procedureId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }


  }


  Createclasses() {
    if (this.classes.length > 0) {
      this.parentColumn1 = true;

    }

    let list = new Classes();
    this.classes.push(list);

  }

  removeclasses(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      const index = this.classes.findIndex(item => item === BO);

      if (index !== -1) {
        this.classes.splice(index, 1);
      }

    } else {
      const index = this.classes.findIndex(item => item === BO);

      if (index !== -1) {
        this.classes.splice(index, 1);
      }

      let url = "api/ServiceDeliveryPlan/DeleteClasses?";
      let params = new URLSearchParams();
      params.append("classId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }


  }


  Createproviders() {
    if (this.serviceplanImportBO.providers.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new Providers();
    this.serviceplanImportBO.providers.push(list);

  }

  removeproviders(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {

      const index = this.serviceplanImportBO.providers.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.providers.splice(index, 1);
      }


    } else {
      const index = this.serviceplanImportBO.providers.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.providers.splice(index, 1);
      }
      let url = "api/ServiceDeliveryPlan/DeleteProvider?";
      let params = new URLSearchParams();
      params.append("iADLId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }


  }


  Createmedicalemergencies() {
    if (this.serviceplanImportBO.medicalEmergencies.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new MedicalEmergencies();
    this.serviceplanImportBO.medicalEmergencies.push(list);

  }

  removemedicalemergencies(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      const index = this.serviceplanImportBO.medicalEmergencies.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.medicalEmergencies.splice(index, 1);
      }

    } else {
      const index = this.serviceplanImportBO.medicalEmergencies.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.medicalEmergencies.splice(index, 1);
      }
      let url = "api/ServiceDeliveryPlan/DeleteMedicalEmergency?";
      let params = new URLSearchParams();
      params.append("medicalEmergencyId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }


  }


  Createnonmedicalemergencies() {
    if (this.serviceplanImportBO.nonMedicalEmergencies.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new NonMedicalEmergencies();
    this.serviceplanImportBO.nonMedicalEmergencies.push(list);

  }

  removenonmedicalemergencies(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      // this.serviceplanImportBO.nonMedicalEmergencies.splice(Contact, 1);
      //this.serviceplanImportBO.nonMedicalEmergencies = this.serviceplanImportBO.nonMedicalEmergencies.filter(item => item.situation !== Contact.situation);
      const index = this.serviceplanImportBO.nonMedicalEmergencies.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.nonMedicalEmergencies.splice(index, 1);
      }
    } else {
      const index = this.serviceplanImportBO.nonMedicalEmergencies.findIndex(item => item === BO);

      if (index !== -1) {
        this.serviceplanImportBO.nonMedicalEmergencies.splice(index, 1);
      } let url = "api/ServiceDeliveryPlan/DeleteNonMedicalEmergency?";
      let params = new URLSearchParams();
      params.append("nonMedicalEmergencyId", BO.id);
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Deleted successfully!")

        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
    }


  }



  drawStartsign(value) {


    // will be notified of szimek/signature_pad's onBegin event
  }

  sign: string = '';
  sign1: string = '';
  drawComplete(value) {

    if (value == 'recipient') {
      this.personwhoaccess_sign = this.personaccesssignaturePad.toDataURL()
    }
    if (value == 'parent') {
      this.parent_sign = this.parentsignaturePad1.toDataURL()
    }
    if (value == 'provider') {
      this.provider_sign = this.providersignaturePad.toDataURL()
    }
    if (value == 'agency') {
      this.agencystaff_sign = this.AgencysignaturePad.toDataURL()
    }

  }

  clearsign() {
    this.personaccesssignaturePad.clear();
    this.personwhoaccess_sign = '';
    this.personwhoaccess_signDate = '';
  }

  close() {
    document.getElementById("openandclosepersonwhoaccess_signModal").click();

  }

  clearparentsign() {
    this.parentsignaturePad1.clear();
    this.parent_sign = '';
    this.parent_signDate = '';
  }

  closeparentsign() {
    document.getElementById("openandcloseparent_signModal").click();

  }

  clearprovidersign() {
    this.providersignaturePad.clear();
    this.provider_sign = '';
    this.provider_signDate = '';
  }

  closeprovidersign() {
    document.getElementById("openandcloseprovider_signModal").click();

  }

  clearAgencysign() {
    this.AgencysignaturePad.clear();
    this.agencystaff_sign = '';
    this.agencystaff_signDate = '';
  }

  closeAgencysign() {
    document.getElementById("openandcloseagencystaff_signModal").click();

  }
  ClearServicePlanform() {
    this.serviceplanImportBO = new ServiceDeliveryPlan();
    this.serviceplanImportBO.participantRepresentative = [];
    this.serviceplanImportBO.participantRepresentative.push(new ParticipantRepresentative())

    this.serviceplanImportBO.interpreters = [];
    this.serviceplanImportBO.interpreters.push(new Interpreter())


    this.serviceplanImportBO.careCoordinator = [];
    this.serviceplanImportBO.careCoordinator.push(new CareCoordinator())


    this.serviceplanImportBO.fmsBudget.workerBudgets = [];
    this.serviceplanImportBO.fmsBudget.workerBudgets.push(new WorkerBudget());

    this.serviceplanImportBO.fmsBudget.workerTasks = [];
    this.serviceplanImportBO.fmsBudget.workerTasks.push(new WorkerTask());

    this.aDls = [];
    this.aDls.push(new ADLs());

    this.instrumentalActivities = [];
    this.instrumentalActivities.push(new InstrumentalActivity());

    this.behaviours = [];
    this.behaviours.push(new Behaviour());
    this.healthProcedures = [];
    this.healthProcedures.push(new HealthProcedures());

    this.classes = [];
    this.classes.push(new Classes());

    let nonmedical: NonMedicalEmergencies[] = [
      {
        id: "00000000-0000-0000-0000-000000000000",
        situation: "Fire",
        special_Instructions: "",
        serviceDeliveryPlanId: "00000000-0000-0000-0000-000000000000"
      },
      {
        id: "00000000-0000-0000-0000-000000000000",
        situation: "Tornado",
        special_Instructions: "",
        serviceDeliveryPlanId: "00000000-0000-0000-0000-000000000000"
      },
      {
        id: "00000000-0000-0000-0000-000000000000",
        situation: "Extreme temperatures",
        special_Instructions: "",
        serviceDeliveryPlanId: "00000000-0000-0000-0000-000000000000"
      },
      {
        id: "00000000-0000-0000-0000-000000000000",
        situation: "Power outage",
        special_Instructions: "",
        serviceDeliveryPlanId: "00000000-0000-0000-0000-000000000000"
      },
      {
        id: "00000000-0000-0000-0000-000000000000",
        situation: "Flood",
        special_Instructions: "",
        serviceDeliveryPlanId: "00000000-0000-0000-0000-000000000000"
      },
    ]
    this.NonMedicalEmergencies = nonmedical;
    this.serviceplanImportBO.nonMedicalEmergencies = this.NonMedicalEmergencies;

    this.serviceplanImportBO.providers = [];
    this.serviceplanImportBO.providers.push(new Providers());
    this.serviceplanImportBO.medicalEmergencies = [];
    this.serviceplanImportBO.medicalEmergencies.push(new MedicalEmergencies());

    this.serviceplanImportBO.agencyModels.agencyDetails = [];
    this.serviceplanImportBO.agencyModels.agencyDetails.push(new AgencyDetails());
    if (this.serviceplanImportBO.modelTypename == "AGENCY") {
      this.goodsAndServices = [
        {
          id: "00000000-0000-0000-0000-000000000000",
          goods_Or_Service: "Estimated annual FMS fee",
          assessed_Need: "N/A",
          human_Support_It_Replaces: "N/A",
          cost: 0,
          fms_Fee_Percentage: null,
          fMSBudgetId: "",
          agenCyModelId: ""
        }


      ]


    }
    this.goodsAndServices.push(new GoodsAndServices());

    this.Goodsgrandtotal = 0
    this.Goodssubtotalcost = 0
    this.Goodssubtotalfee = 0
    this.Workergrandtotal = 0
    this.classtotal = 0
    this.FMSProvider = new FMSProvider();
    this.AnnualTotal = 0;
    this.Unusedbudget = 0;
    this.serviceplanImportBO.revisionDate = null;

this.serviceplanImportBO.revisionTypes = {
  participantRepresentative: false,
  goodsAndServices: false,
  pers: false,
  workerTraining: false,
  changingProviders: false
};

this.serviceplanImportBO.providerChangeTypes = {
  consultationServicesProvider: false,
  cfssProviderAgency: false,
  persProvider: false,
  fmsProvider: false
};


  }
  public saveAuthErr: string = '';
  checkdate() {
   console.log(this.serviceplanImportBO);
    if (this.serviceplanImportBO.plandate == null || this.serviceplanImportBO.plandate == "" || this.serviceplanImportBO.plandate == undefined) {
      this.saveAuthErr = "Plan date is important";
      this.toastrService.error(this.saveAuthErr);
    }

    else if (this.serviceplanImportBO.startdate == null || this.serviceplanImportBO.startdate == "" || this.serviceplanImportBO.startdate == undefined) {
      this.saveAuthErr = "Start date is important";
      this.toastrService.error(this.saveAuthErr);
    }


    else if (this.serviceplanImportBO.enddate == null || this.serviceplanImportBO.enddate == "" || this.serviceplanImportBO.enddate == undefined) {
      this.saveAuthErr = "End date is important";
      this.toastrService.error(this.saveAuthErr);
    }

    else if (this.serviceplanImportBO.version == null || this.serviceplanImportBO.version == "" || this.serviceplanImportBO.version == undefined) {
      this.saveAuthErr = "Version is important";
      this.toastrService.error(this.saveAuthErr);
    }

    else if (this.serviceplanImportBO.totalCFSSUnitsEligible == null || this.serviceplanImportBO.totalCFSSUnitsEligible == 0 || this.serviceplanImportBO.totalCFSSUnitsEligible == undefined ) {
      this.saveAuthErr = "Total CFSS units is important";
      this.toastrService.error(this.saveAuthErr);
    }
    else if(isNaN(this.serviceplanImportBO.totalCFSSUnitsEligible)){
      this.saveAuthErr = "Total CFSS units is invalid";
      this.toastrService.error(this.saveAuthErr);
    }

    else if (new Date(this.serviceplanImportBO.startdate).getTime() > new Date(this.serviceplanImportBO.enddate).getTime()) {

      this.saveAuthErr = "End date must be larger than start date";
      this.toastrService.error(this.saveAuthErr);

    }
    else if (this.serviceplanImportBO.modelTypename == null || this.serviceplanImportBO.modelTypename == "" || this.serviceplanImportBO.modelTypename == undefined) {

      this.saveAuthErr = "CFSS Model type is empty";
      this.toastrService.error(this.saveAuthErr);

    }
    else {
      this.saveAuthErr = '';
    }
    if (this.saveAuthErr == "") {


      if (this.serviceplanImportBO.id == '00000000-0000-0000-0000-000000000000') {
        this.SaveServicedeliveryplan();
      }
      else if (this.servicePlan.copy == true) {

        this.CopyServicedeliveryplan();
      } else {
        this.UpdateServicedeliveryplan();
      }


    }


  }

  checkvalidation() {
  
    if (this.serviceplanImportBO.plandate == null || this.serviceplanImportBO.plandate == "" || this.serviceplanImportBO.plandate == undefined) {
      this.saveAuthErr = "Plan date is important";
      this.toastrService.error(this.saveAuthErr);
    }

    else if (this.serviceplanImportBO.startdate == null || this.serviceplanImportBO.startdate == "" || this.serviceplanImportBO.startdate == undefined) {
      this.saveAuthErr = "Start date is important";
      this.toastrService.error(this.saveAuthErr);
    }


    else if (this.serviceplanImportBO.enddate == null || this.serviceplanImportBO.enddate == "" || this.serviceplanImportBO.enddate == undefined) {
      this.saveAuthErr = "End date is important";
      this.toastrService.error(this.saveAuthErr);
    }

    else if (this.serviceplanImportBO.version == null || this.serviceplanImportBO.version == "" || this.serviceplanImportBO.version == undefined) {
      this.saveAuthErr = "Version is important";
      this.toastrService.error(this.saveAuthErr);
    }

    else if (new Date(this.serviceplanImportBO.startdate).getTime() > new Date(this.serviceplanImportBO.enddate).getTime()) {

      this.saveAuthErr = "End date must be larger than start date";
      this.toastrService.error(this.saveAuthErr);

    }
    else if (this.serviceplanImportBO.modelTypename == null || this.serviceplanImportBO.modelTypename == "" || this.serviceplanImportBO.modelTypename == undefined) {

      this.saveAuthErr = "CFSS Model type is empty";
      this.toastrService.error(this.saveAuthErr);

    }
    else {
      this.saveAuthErr = '';
    }
    if (this.saveAuthErr == "") {
      

      this.createEvents();


    }


  }

  validchange_agencyModel(index, val) {
    if (val.phoneNumber != '' && val.phoneNumber != null && val.phoneNumber != undefined) {
      if (val.phoneNumber.length != 14) {


        this.errphone1[index] = true
        this.phonerr1[index] = 'Enter Valid phone, Enter 10 digit'
        // this.bool2 = true

      }
      else {

        this.errphone1[index] = false
        this.phonerr1[index] = ''
        // this.bool2 = false
      }
    } else {
      this.errphone1[index] = false
      // this.bool2 = false
      this.phonerr1[index] = ''

    }

  }

  validchange_fax(index, val) {
    if (val.faxNumber != '' && val.faxNumber != null && val.faxNumber != undefined) {
      if (val.faxNumber.length != 14) {


        this.errfax[index] = true
        this.faxerr[index] = 'Enter Valid fax, Enter 10 digit'


      }
      else {

        this.errfax[index] = false
        this.faxerr[index] = ''
      }
    } else {
      this.errfax[index] = false
      this.faxerr[index] = ''

    }

  }
  validchangeZip(index, val) {
    if (val.zipcode != '' && val.zipcode != null && val.zipcode != undefined) {
      if (val.zipcode.length <= 4) {


        this.errZip[index] = true
        this.ziperr[index] = 'Enter Valid zip, Enter  5 to 11 digits'
        // this.bool4 = true

      }
      else {

        this.errZip[index] = false
        this.ziperr[index] = ''
        // this.bool4 = false
      }
    } else {
      this.errZip[index] = false
      // this.bool4 = false
      this.ziperr[index] = ''

    }

  }


  validchangeCaseZip(index, val) {
    if (val.zipCode != '' && val.zipCode != null && val.zipCode != undefined) {
      if (val.zipCode.length <= 4) {


        this.errCaseZip[index] = true
        this.Caseziperr[index] = 'Enter Valid zip, Enter  5 to 11 digits'
        // this.bool4 = true

      }
      else {

        this.errCaseZip[index] = false
        this.Caseziperr[index] = ''
        // this.bool4 = false
      }
    } else {
      this.errCaseZip[index] = false
      // this.bool4 = false
      this.Caseziperr[index] = ''

    }

  }

  validchange_CasePhn(index, val) {
    if (val.phoneNumber != '' && val.phoneNumber != null && val.phoneNumber != undefined) {
      if (val.phoneNumber.length != 14) {


        this.errCasePhn[index] = true
        this.CasePhnerr[index] = 'Enter Valid phone, Enter 10 digit'
        // this.bool2 = true

      }
      else {

        this.errCasePhn[index] = false
        this.CasePhnerr[index] = ''
        // this.bool2 = false
      }
    } else {
      this.errCasePhn[index] = false
      // this.bool2 = false
      this.CasePhnerr[index] = ''

    }

  }

  validchange_Casefax(index, val) {
    if (val.fax != '' && val.fax != null && val.fax != undefined) {
      if (val.phoneNumber.length != 14) {


        this.errCasefax[index] = true
        this.Casefaxerr[index] = 'Enter Valid phone, Enter 10 digit'
        // this.bool2 = true

      }
      else {

        this.errCasefax[index] = false
        this.Casefaxerr[index] = ''
        // this.bool2 = false
      }
    } else {
      this.errCasefax[index] = false
      // this.bool2 = false
      this.Casefaxerr[index] = ''

    }

  }



  validchangeParticipantZip(index, val) {
    if (val.zipCode != '' && val.zipCode != null && val.zipCode != undefined) {
      if (val.zipCode.length <= 4) {


        this.errParticipantZip[index] = true
        this.Participantziperr[index] = 'Enter Valid zip, Enter  5 to 11 digits'
        // this.bool4 = true

      }
      else {

        this.errParticipantZip[index] = false
        this.Participantziperr[index] = ''
        // this.bool4 = false
      }
    } else {
      this.errParticipantZip[index] = false
      // this.bool4 = false
      this.Participantziperr[index] = ''

    }

  }

  validchange_ParicipantPhn(index, val) {
    if (val.phoneNumber != '' && val.phoneNumber != null && val.phoneNumber != undefined) {
      if (val.phoneNumber.length != 14) {


        this.errparticipantPhn[index] = true
        this.ParticipantPhnerr[index] = 'Enter Valid phone, Enter 10 digit'
        // this.bool2 = true

      }
      else {

        this.errparticipantPhn[index] = false
        this.ParticipantPhnerr[index] = ''
        // this.bool2 = false
      }
    } else {
      this.errparticipantPhn[index] = false
      // this.bool2 = false
      this.ParticipantPhnerr[index] = ''

    }

  }



  validchange_InterpreterPhn(index, val) {
    if (val.phoneNumber != '' && val.phoneNumber != null && val.phoneNumber != undefined) {
      if (val.phoneNumber.length != 14) {


        this.errInterpreterPhn[index] = true
        this.InterpreterPhnerr[index] = 'Enter Valid phone, Enter 10 digit'
        // this.bool2 = true

      }
      else {

        this.errInterpreterPhn[index] = false
        this.InterpreterPhnerr[index] = ''
        // this.bool2 = false
      }
    } else {
      this.errInterpreterPhn[index] = false
      // this.bool2 = false
      this.InterpreterPhnerr[index] = ''

    }

  }

  validchange_ProviderPhn(index, val) {
    if (val.phoneNumber != '' && val.phoneNumber != null && val.phoneNumber != undefined) {
      if (val.phoneNumber.length != 14) {


        this.errproviderPhn[index] = true
        this.providerPhnerr[index] = 'Enter Valid phone, Enter 10 digit'
        // this.bool2 = true

      }
      else {

        this.errproviderPhn[index] = false
        this.providerPhnerr[index] = ''
        // this.bool2 = false
      }
    } else {
      this.errproviderPhn[index] = false
      // this.bool2 = false
      this.providerPhnerr[index] = ''

    }

  }


  SaveServicedeliveryplan() {

    let serviceplan: ServiceDeliveryPlan = JSON.parse(JSON.stringify(this.serviceplanImportBO));
console.log(serviceplan);
console.log('check above');

    if (this.goodsAndServices.length > 0) {
      if (this.goodsAndServices.length == 1 && (this.goodsAndServices[0].goods_Or_Service == null || this.goodsAndServices[0].goods_Or_Service == "") && (this.goodsAndServices[0].cost == null || this.goodsAndServices[0].cost == 0)) {
        this.goodsAndServices = [];
      }
      else {
        this.goodsAndServices = this.goodsAndServices.filter(e => (e.goods_Or_Service != null && e.goods_Or_Service != "") || (e.cost != null && e.cost != 0))
        this.goodsAndServices.forEach(i => {

          if (i.cost != null && i.cost != undefined && i.cost != 0) {
            i.cost = parseFloat(i.cost.toString())
          }
          else {

            i.cost = 0
          }

          i.fms_Fee_Percentage = (i.fms_Fee_Percentage != null && i.fms_Fee_Percentage != undefined && i.fms_Fee_Percentage != 0) ? parseFloat(i.fms_Fee_Percentage.toString()) : null;

        })


      }

    }
    serviceplan.goodsAndServices = this.goodsAndServices;

    if (this.aDls.length > 0) {
      if (this.aDls.length == 1 && (this.aDls[0].assesedNeed == "" || this.aDls[0].assesedNeed == null) && (this.aDls[0].fromWhom == "" || this.aDls[0].fromWhom == null)) {
        this.aDls = [];
      }
      else {
        this.aDls = this.aDls.filter(e => ((e.assesedNeed != null && e.assesedNeed != "") || (e.fromWhom != null && e.fromWhom != "") || (e.how_will_Caregiver_do != null && e.how_will_Caregiver_do != "") || (e.what_will_Caregiver_do != null && e.what_will_Caregiver_do != "")))

      }

    }
    serviceplan.adLs = this.aDls;

    if (this.instrumentalActivities.length > 0) {
      if (this.instrumentalActivities.length == 1 && (this.instrumentalActivities[0].assesedNeed == null || this.instrumentalActivities[0].assesedNeed == "") && (this.instrumentalActivities[0].how_will_Caregiver_do == null || this.instrumentalActivities[0].how_will_Caregiver_do == "") && (this.instrumentalActivities[0].what_will_Caregiver_do == null || this.instrumentalActivities[0].what_will_Caregiver_do == "")) {
        this.instrumentalActivities = [];
      }
      else {
        this.instrumentalActivities = this.instrumentalActivities.filter(e => ((e.assesedNeed != null && e.assesedNeed != "") || (e.how_will_Caregiver_do != null && e.how_will_Caregiver_do != "") || (e.what_will_Caregiver_do != null && e.what_will_Caregiver_do != "")))

      }

    }
    serviceplan.instrumentalActivities = this.instrumentalActivities;


    if (this.NonMedicalEmergencies.length > 0) {
      if (this.NonMedicalEmergencies.length == 1 && (this.NonMedicalEmergencies[0].situation == null || this.NonMedicalEmergencies[0].situation == "") && (this.NonMedicalEmergencies[0].special_Instructions == null || this.NonMedicalEmergencies[0].special_Instructions == "")) {
        this.NonMedicalEmergencies = [];
      }
      else {
        this.NonMedicalEmergencies = this.NonMedicalEmergencies.filter(e => ((e.situation != null && e.situation != "") || (e.special_Instructions != null && e.special_Instructions != "")))

      }

    }
    serviceplan.nonMedicalEmergencies = this.NonMedicalEmergencies;


    if (this.behaviours.length > 0) {
      if (this.behaviours.length == 1 && (this.behaviours[0].it_means == null || this.behaviours[0].it_means == "") && (this.behaviours[0].when_I_do == null || this.behaviours[0].when_I_do == "") && (this.behaviours[0].worker_can_help_by == null || this.behaviours[0].worker_can_help_by == "")) {
        this.behaviours = [];
      }
      else {
        this.behaviours = this.behaviours.filter(e => ((e.it_means != null && e.it_means != "") || (e.when_I_do != null && e.when_I_do != "") || (e.worker_can_help_by != null && e.worker_can_help_by != "")))

      }

    }
    serviceplan.behaviours = this.behaviours;


    if (this.healthProcedures.length > 0) {
      if (this.healthProcedures.length == 1 && (this.healthProcedures[0].how_will_worker_do == null || this.healthProcedures[0].how_will_worker_do == "") && (this.healthProcedures[0].need == null || this.healthProcedures[0].need == "") && (this.healthProcedures[0].what_will_worker_do == null || this.healthProcedures[0].what_will_worker_do == "")) {
        this.healthProcedures = [];
      }
      else {
        this.healthProcedures = this.healthProcedures.filter(e => ((e.how_will_worker_do != null && e.how_will_worker_do != "") || (e.need != null && e.need != "") || (e.what_will_worker_do != null && e.what_will_worker_do != "")))


      }

    }
    serviceplan.healthProcedures = this.healthProcedures;

    if (this.classes.length > 0) {
      if (this.classes.length == 1 && (this.classes[0].className == null || this.classes[0].className == "") && (this.classes[0].cost == null || this.classes[0].cost == 0) && (this.classes[0].trainingProvider == null || this.classes[0].trainingProvider == "")) {
        this.classes = [];
      }
      else {
        this.classes = this.classes.filter(e => ((e.className != null && e.className != "") || (e.cost != null && e.cost != 0) || (e.trainingProvider != null && e.trainingProvider != "")))

        this.classes.forEach(i => {
          i.cost = (i.cost != null && i.cost != undefined && i.cost) ? parseFloat(i.cost.toString()) : 0;

        })
      }

    }
    serviceplan.classes = this.classes;
    // if (this.classes.length > 0) {
    //   if (this.classes.length == 1 && this.classes[0].className == null && this.classes[0].cost == null && this.classes[0].trainingProvider == null) {
    //     this.classes = [];
    //   }
    //   else {
    //     this.classes = this.classes.filter(e => (e.className != null || e.cost != null || e.trainingProvider != null))

    //     this.classes.forEach(i => {
    //       i.cost = (i.cost != null && i.cost != undefined && i.cost) ? parseFloat(i.cost.toString()) : null;

    //     })
    //   }

    // }
    if (serviceplan.providers.length > 0) {
      if (serviceplan.providers.length == 1 && (serviceplan.providers[0].phoneNumber == null || serviceplan.providers[0].phoneNumber == "") && (serviceplan.providers[0].address == null || serviceplan.providers[0].address == "") && (serviceplan.providers[0].providerName == null || serviceplan.providers[0].providerName == "") && (serviceplan.providers[0].specialty == null || serviceplan.providers[0].specialty == "")) {
        serviceplan.providers = [];
      }
      else {
        serviceplan.providers = serviceplan.providers.filter(e => ((e.phoneNumber != "" && e.phoneNumber != null) || (e.address != null && e.address != "") || (e.providerName != null && e.providerName != "") || (e.specialty != null && e.specialty != "")))


      }

    }
    if (serviceplan.medicalEmergencies.length > 0) {
      if (serviceplan.medicalEmergencies.length == 1 && (serviceplan.medicalEmergencies[0].if_this_happens == null || serviceplan.medicalEmergencies[0].if_this_happens == "") && (serviceplan.medicalEmergencies[0].contact == null || serviceplan.medicalEmergencies[0].contact == "") && (serviceplan.medicalEmergencies[0].specialInstructions == null || serviceplan.medicalEmergencies[0].specialInstructions == "")) {
        serviceplan.medicalEmergencies = [];
      }
      else {
        serviceplan.medicalEmergencies = serviceplan.medicalEmergencies.filter(e => ((e.if_this_happens != null && e.if_this_happens != "") || (e.contact != null && e.contact != "") || (e.specialInstructions != null && e.specialInstructions != "")))


      }

    }
    if (serviceplan.interpreters.length > 0) {
      if (serviceplan.interpreters.length == 1 && (serviceplan.interpreters[0].name == null || serviceplan.interpreters[0].name == "") && (serviceplan.interpreters[0].phonenumer == null || serviceplan.interpreters[0].phonenumer == "") && (serviceplan.interpreters[0].relationShip == null || serviceplan.interpreters[0].relationShip == "")) {
        serviceplan.interpreters = [];
      }
      else {
        serviceplan.interpreters = serviceplan.interpreters.filter(e => ((e.name != null && e.name != "") || (e.phonenumer != null && e.phonenumer != "") || (e.relationShip != null && e.relationShip != "")))


      }

    }
    if (serviceplan.careCoordinator.length > 0) {
      if (serviceplan.careCoordinator.length == 1 && (serviceplan.careCoordinator[0].coordinator_Name == null || serviceplan.careCoordinator[0].coordinator_Name == "") && (serviceplan.careCoordinator[0].coordinator_Name == null || serviceplan.careCoordinator[0].coordinator_Name == "") && (serviceplan.careCoordinator[0].email == null || serviceplan.careCoordinator[0].email == "")
        && (serviceplan.careCoordinator[0].fax == null || serviceplan.careCoordinator[0].fax == "") && (serviceplan.careCoordinator[0].state == null || serviceplan.careCoordinator[0].state == "") && (serviceplan.careCoordinator[0].city == null || serviceplan.careCoordinator[0].city == "") && (serviceplan.careCoordinator[0].street == null || serviceplan.careCoordinator[0].street == "") && (serviceplan.careCoordinator[0].zipCode == null || serviceplan.careCoordinator[0].zipCode == "")
      ) {
        serviceplan.careCoordinator = [];
      }
      else {
        serviceplan.careCoordinator = serviceplan.careCoordinator.filter(e => ((e.coordinator_Name != null && e.coordinator_Name != "") || (e.phoneNumber != null && e.phoneNumber != "") || (e.city != null && e.city != "") || (e.state != null && e.state != "") || (e.email != null && e.email != "") || (e.fax != null && e.fax != "")
          || (e.street != null && e.street != "") || (e.zipCode != "" && e.zipCode != null)
        ))


      }

    }

    if (serviceplan.participantRepresentative.length > 0) {
      if (serviceplan.participantRepresentative.length == 1 && (serviceplan.participantRepresentative[0].firstName == null || serviceplan.participantRepresentative[0].firstName == "") && (serviceplan.participantRepresentative[0].lastName == null || serviceplan.participantRepresentative[0].lastName == "") && (serviceplan.participantRepresentative[0].address == null || serviceplan.participantRepresentative[0].address == "")
        && (serviceplan.participantRepresentative[0].city == null || serviceplan.participantRepresentative[0].city == "") && (serviceplan.participantRepresentative[0].email == null || serviceplan.participantRepresentative[0].email == "") && (serviceplan.participantRepresentative[0].phoneNumber == null || serviceplan.participantRepresentative[0].phoneNumber == "")
        && (serviceplan.participantRepresentative[0].state == null || serviceplan.participantRepresentative[0].state == "") && (serviceplan.participantRepresentative[0].zipCode == null || serviceplan.participantRepresentative[0].zipCode == "")
      ) {
        serviceplan.participantRepresentative = [];
      }
      else {
        serviceplan.participantRepresentative = serviceplan.participantRepresentative.filter(e => ((e.firstName != null && e.firstName != "") || (e.lastName != null && e.lastName != "") || (e.phoneNumber != null && e.phoneNumber != "") || (e.address != null && e.address != "") || (e.city != null && e.city != "") || (e.email != null || e.email != ""
        ) || (e.state != null || e.state != "") || (e.zipCode != null || e.zipCode != "")
        ))


      }

    }

    if (serviceplan.agencyModels?.agencyDetails.length > 0) {
      if (serviceplan.agencyModels.agencyDetails.length == 1 && (serviceplan.agencyModels.agencyDetails[0].agencyName == null || serviceplan.agencyModels.agencyDetails[0].agencyName == "") && (serviceplan.agencyModels.agencyDetails[0].contactName == null || serviceplan.agencyModels.agencyDetails[0].contactName == "") && (serviceplan.agencyModels.agencyDetails[0].street == null || serviceplan.agencyModels.agencyDetails[0].street == "")
        && (serviceplan.agencyModels.agencyDetails[0].city == null || serviceplan.agencyModels.agencyDetails[0].city == "") && (serviceplan.agencyModels.agencyDetails[0].emailAddress == null || serviceplan.agencyModels.agencyDetails[0].emailAddress == "") && (serviceplan.agencyModels.agencyDetails[0].phoneNumber == null || serviceplan.agencyModels.agencyDetails[0].phoneNumber == "")
        && (serviceplan.agencyModels.agencyDetails[0].state == null || serviceplan.agencyModels.agencyDetails[0].state == "") && (serviceplan.agencyModels.agencyDetails[0].zipCode == null || serviceplan.agencyModels.agencyDetails[0].zipCode == "")
      ) {
        serviceplan.agencyModels.agencyDetails = [];
      }
      else {
        serviceplan.agencyModels.agencyDetails = serviceplan.agencyModels.agencyDetails.filter(e => ((e.agencyName != null && e.agencyName != "") || (e.contactName != null && e.contactName != "") || (e.phoneNumber != null && e.phoneNumber != "") || (e.state != null && e.state != "") || (e.city != null && e.city != "") || (e.emailAddress != null && e.emailAddress != "")
          || (e.street != null && e.street != "") || (e.zipCode != null && e.zipCode != "")
        ))


      }

    }
    if (serviceplan.fmsBudget?.workerBudgets.length > 0) {
      if (serviceplan.fmsBudget.workerBudgets.length == 1 && (serviceplan.fmsBudget.workerBudgets[0].hourly_Wage == null || serviceplan.fmsBudget.workerBudgets[0].hourly_Wage == 0) && (serviceplan.fmsBudget.workerBudgets[0].is_PTO_Applied == null) && serviceplan.fmsBudget.workerBudgets[0].is_Payroll_Applied == null
        && serviceplan.fmsBudget.workerBudgets[0].is_Worker_Comp_Applied == null && (serviceplan.fmsBudget.workerBudgets[0].no_Of_Hours_Per_Week == null || serviceplan.fmsBudget.workerBudgets[0].no_Of_Hours_Per_Week == 0) && (serviceplan.fmsBudget.workerBudgets[0].no_Of_Weeks == null || serviceplan.fmsBudget.workerBudgets[0].no_Of_Weeks == 0) && (serviceplan.fmsBudget.workerBudgets[0].totalCost == null || serviceplan.fmsBudget.workerBudgets[0].totalCost == 0)
        && (serviceplan.fmsBudget.workerBudgets[0].worker_Name == null || serviceplan.fmsBudget.workerBudgets[0].worker_Name == "")
      ) {
        serviceplan.fmsBudget.workerBudgets = [];
      }
      else {
        serviceplan.fmsBudget.workerBudgets = serviceplan.fmsBudget.workerBudgets.filter(e => ((e.hourly_Wage != null && e.hourly_Wage != 0) || (e.is_PTO_Applied != null) || e.is_Payroll_Applied != null || e.is_Worker_Comp_Applied != null || (e.no_Of_Hours_Per_Week != null && e.no_Of_Hours_Per_Week != 0) || (e.no_Of_Weeks != null && e.no_Of_Weeks != 0)
          || (e.totalCost != null && e.totalCost != 0) || (e.worker_Name != null && e.worker_Name != "")
        ))


        serviceplan.fmsBudget.workerBudgets.forEach(i => {
          i.hourly_Wage = (i.hourly_Wage != null && i.hourly_Wage != undefined && i.hourly_Wage != 0) ? parseFloat(i.hourly_Wage.toString()) : 0;
          i.no_Of_Hours_Per_Week = (i.no_Of_Hours_Per_Week != null && i.no_Of_Hours_Per_Week != undefined && i.no_Of_Hours_Per_Week != 0) ? parseFloat(i.no_Of_Hours_Per_Week.toString()) : 0;
          i.no_Of_Weeks = (i.no_Of_Weeks != null && i.no_Of_Weeks != undefined && i.no_Of_Weeks != 0) ? parseFloat(i.no_Of_Weeks.toString()) : 0;
          i.totalCost = (i.totalCost != null && i.totalCost != undefined && i.totalCost != 0) ? parseFloat(i.totalCost.toString()) : 0;
          i.percentageRate = (i.percentageRate != null && i.percentageRate != undefined && i.percentageRate != 0) ? parseFloat(i.percentageRate.toString()) : 0;

        })


      }

    }

    if (serviceplan.fmsBudget?.workerTasks.length > 0) {
      if (serviceplan.fmsBudget.workerTasks.length == 1 && (serviceplan.fmsBudget.workerTasks[0].qualifications == null || serviceplan.fmsBudget.workerTasks[0].qualifications == "") && (serviceplan.fmsBudget.workerTasks[0].task == null || serviceplan.fmsBudget.workerTasks[0].task == "")
      ) {
        serviceplan.fmsBudget.workerTasks = [];
      }
      else {
        serviceplan.fmsBudget.workerTasks = serviceplan.fmsBudget.workerTasks.filter(e => ((e.qualifications != null && e.qualifications != "") || (e.task != null && e.task != "")

        ))




      }

    }
    if (serviceplan.agencyModels.monthlyUnitUsage.totalUnitsUsed != null && serviceplan.agencyModels.monthlyUnitUsage.totalUnitsUsed != 0) {
      serviceplan.agencyModels.monthlyUnitUsage.totalUnitsUsed = Number(serviceplan.agencyModels.monthlyUnitUsage.totalUnitsUsed)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsJan != null && serviceplan.agencyModels.monthlyUnitUsage.unitsJan != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsJan.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsJan = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsJan)
    }

    if (serviceplan.agencyModels.monthlyUnitUsage.unitsFeb != null && serviceplan.agencyModels.monthlyUnitUsage.unitsFeb != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsFeb.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsFeb = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsFeb)
    }

    if (serviceplan.agencyModels.monthlyUnitUsage.unitsMar != null && serviceplan.agencyModels.monthlyUnitUsage.unitsMar != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsMar.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsMar = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsMar)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsApr != null && serviceplan.agencyModels.monthlyUnitUsage.unitsApr != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsApr.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsApr = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsApr)
    }

    if (serviceplan.agencyModels.monthlyUnitUsage.unitsMay != null && serviceplan.agencyModels.monthlyUnitUsage.unitsMay != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsMay.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsMay = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsMay)
    }


    if (serviceplan.agencyModels.monthlyUnitUsage.unitsJun != null && serviceplan.agencyModels.monthlyUnitUsage.unitsJun != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsJun.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsJun = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsJun)
    }

    if (serviceplan.agencyModels.monthlyUnitUsage.unitsJul != null && serviceplan.agencyModels.monthlyUnitUsage.unitsJul != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsJul.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsJul = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsJul)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsAug != null && serviceplan.agencyModels.monthlyUnitUsage.unitsAug != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsAug.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsAug = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsAug)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsSep != null && serviceplan.agencyModels.monthlyUnitUsage.unitsSep != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsSep.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsSep = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsSep)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsOct != null && serviceplan.agencyModels.monthlyUnitUsage.unitsOct != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsOct.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsOct = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsOct)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsNov != null && serviceplan.agencyModels.monthlyUnitUsage.unitsNov != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsNov.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsNov = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsNov)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsDec != null && serviceplan.agencyModels.monthlyUnitUsage.unitsDec != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsDec.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsDec = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsDec)
    }
    serviceplan.fmsProvider = this.FMSProvider;
    serviceplan.fmsProvider.providerKeyValue = null;
    serviceplan.mhcpCost.equipment_Cost = (serviceplan.mhcpCost.equipment_Cost != null && serviceplan.mhcpCost.equipment_Cost != 0) ? Number(serviceplan.mhcpCost.equipment_Cost) : 0
    serviceplan.mhcpCost.installation_Cost = (serviceplan.mhcpCost.installation_Cost != null && serviceplan.mhcpCost.installation_Cost != 0) ? Number(serviceplan.mhcpCost.installation_Cost) : 0
    serviceplan.mhcpCost.subscription_Cost = (serviceplan.mhcpCost.subscription_Cost != null && serviceplan.mhcpCost.subscription_Cost != 0) ? Number(serviceplan.mhcpCost.subscription_Cost) : 0

    serviceplan.clientId = this.servicePlan.clientId
    serviceplan.personDob = (this.clientdob != null && this.clientdob != undefined && this.clientdob != '' && this.clientdob != null) ? this.global.getDateTimeString(this.clientdob) : null;

    serviceplan.plandate = (serviceplan.plandate != null && serviceplan.plandate != undefined && serviceplan.plandate != '' && serviceplan.plandate != null) ? this.global.getDateTimeString(serviceplan.plandate) : null;
    serviceplan.startdate = (serviceplan.startdate != null && serviceplan.startdate != undefined && serviceplan.startdate != '' && serviceplan.startdate != null) ? this.global.getDateTimeString(serviceplan.startdate) : null;
    serviceplan.enddate = (serviceplan.enddate != null && serviceplan.enddate != undefined && serviceplan.enddate != '' && serviceplan.enddate != null) ? this.global.getDateTimeString(serviceplan.enddate) : null;
    serviceplan.leadSignDate = (serviceplan.leadSignDate != null && serviceplan.leadSignDate != undefined && serviceplan.leadSignDate != '' && serviceplan.leadSignDate != null) ? this.global.getDateTimeString(serviceplan.leadSignDate) : null;
    serviceplan.providerSignDate = (serviceplan.providerSignDate != null && serviceplan.providerSignDate != undefined && serviceplan.providerSignDate != '' && serviceplan.providerSignDate != null) ? this.global.getDateTimeString(serviceplan.providerSignDate) : null;
    serviceplan.personSignDate = (serviceplan.personSignDate != null && serviceplan.personSignDate != undefined && serviceplan.personSignDate != '' && serviceplan.personSignDate != null) ? this.global.getDateTimeString(serviceplan.personSignDate) : null;
    serviceplan.parentalSignDate = (serviceplan.parentalSignDate != null && serviceplan.parentalSignDate != undefined && serviceplan.parentalSignDate != '' && serviceplan.parentalSignDate != null) ? this.global.getDateTimeString(serviceplan.parentalSignDate) : null;

    serviceplan.clientInfoDob = (serviceplan.clientInfoDob != null && serviceplan.clientInfoDob != undefined && serviceplan.clientInfoDob != '' && serviceplan.clientInfoDob != null) ? this.global.getDateTimeString(serviceplan.clientInfoDob) : null;
serviceplan.revisionDate = (serviceplan.revisionDate != null && serviceplan.revisionDate != undefined && serviceplan.revisionDate != '') ? this.global.getDateTimeString(serviceplan.revisionDate) : null;
    serviceplan.signatureBOs = [];
    if (this.parent_sign != null && this.parent_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.parent_sign;
      Bo.fileName = "PARENTSIGN";
      serviceplan.signatureBOs.push(Bo)
    }
    if (this.provider_sign != null && this.provider_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.provider_sign;
      Bo.fileName = "PROVIDERSIGN";
      serviceplan.signatureBOs.push(Bo)
    } if (this.agencystaff_sign != null && this.agencystaff_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.agencystaff_sign;
      Bo.fileName = "LEADAGENCYSIGN";
      serviceplan.signatureBOs.push(Bo)
    }
    if (this.personwhoaccess_sign != null && this.personwhoaccess_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.personwhoaccess_sign;
      Bo.fileName = "PERSONSIGN";
      serviceplan.signatureBOs.push(Bo)
    }
    serviceplan.signatureBOs = serviceplan.signatureBOs.filter(e => (e.signatureFileString != null && e.signatureFileString != null))

    serviceplan.parentalSignFilePath = this.parent_sign;
    serviceplan.providerSignFilePath = this.provider_sign;
    serviceplan.leadSignFilePath = this.agencystaff_sign;
    serviceplan.personSignFilePath = this.personwhoaccess_sign;
    serviceplan.totalCFSSUnitsEligible = (serviceplan?.totalCFSSUnitsEligible != null && serviceplan?.totalCFSSUnitsEligible != undefined && serviceplan?.totalCFSSUnitsEligible != 0) ? Number(serviceplan.totalCFSSUnitsEligible) : 0
    serviceplan.fmsBudget.budgetAmount = (serviceplan?.fmsBudget?.budgetAmount != null && serviceplan?.fmsBudget?.budgetAmount != undefined && serviceplan?.fmsBudget?.budgetAmount != 0) ? Number(serviceplan?.fmsBudget?.budgetAmount) : 0
    serviceplan.fmsBudget.fmsFee = (serviceplan?.fmsBudget?.fmsFee != null && serviceplan?.fmsBudget?.fmsFee != undefined && serviceplan.fmsBudget.fmsFee != 0) ? Number(serviceplan?.fmsBudget?.fmsFee) : 0
    serviceplan.fmsBudget.planMonths = (serviceplan?.fmsBudget?.planMonths != null && serviceplan?.fmsBudget?.planMonths != undefined && serviceplan.fmsBudget?.planMonths != 0) ? Number(serviceplan?.fmsBudget?.planMonths) : 0
    serviceplan.agencyModels.plannedUnits = (serviceplan?.agencyModels?.plannedUnits != null && serviceplan?.agencyModels?.plannedUnits != undefined && serviceplan.agencyModels?.plannedUnits != 0) ? Number(serviceplan?.agencyModels?.plannedUnits) : 0
    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_ServiceDeliveryPlan/SaveAndUpdateServiceDeliveryPlan";
      }
      else{

         url = "api/ServiceDeliveryPlan/SaveAndUpdateServiceDeliveryPlan";
      }
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(serviceplan, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      //====================== sucess message =============
      if (serviceplan.id == '00000000-0000-0000-0000-000000000000' || serviceplan.id == undefined) {
        serviceplan.id = data;
        this.eventdisable = false;
        this.toastrService.success('Service Delivery Plan Imported Successfully');

        this.servicePlan.serviceDeliveryPlanId = data;
        this.getServiceDeliverPlanDetails();
        this.changevalue = false;
        // this.showtable()
      }

      // this.closeFun();
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err);
      }
      else {
        this.toastrService.error(err);
      }

    })


  }


  UpdateServicedeliveryplan() {

    let serviceplan: ServiceDeliveryPlan = JSON.parse(JSON.stringify(this.serviceplanImportBO));


    if (this.goodsAndServices.length > 0) {
      if (this.goodsAndServices.length == 1 && (this.goodsAndServices[0].goods_Or_Service == null || this.goodsAndServices[0].goods_Or_Service == "") && (this.goodsAndServices[0].cost == null || this.goodsAndServices[0].cost == 0)) {
        this.goodsAndServices = [];
      }
      else {
        this.goodsAndServices = this.goodsAndServices.filter(e => (e.goods_Or_Service != null && e.goods_Or_Service != "") || (e.cost != null && e.cost != 0))
        this.goodsAndServices.forEach(i => {

          if (i.cost != null && i.cost != undefined && i.cost != 0) {
            i.cost = parseFloat(i.cost.toString())
          }
          else {

            i.cost = 0
          }

          i.fms_Fee_Percentage = (i.fms_Fee_Percentage != null && i.fms_Fee_Percentage != undefined && i.fms_Fee_Percentage != 0) ? parseFloat(i.fms_Fee_Percentage.toString()) : null;

        })


      }

    }
    serviceplan.goodsAndServices = this.goodsAndServices;

    if (this.aDls.length > 0) {
      if (this.aDls.length == 1 && (this.aDls[0].assesedNeed == "" || this.aDls[0].assesedNeed == null) && (this.aDls[0].fromWhom == "" || this.aDls[0].fromWhom == null)) {
        this.aDls = [];
      }
      else {
        this.aDls = this.aDls.filter(e => ((e.assesedNeed != null && e.assesedNeed != "") || (e.fromWhom != null && e.fromWhom != "") || (e.how_will_Caregiver_do != null && e.how_will_Caregiver_do != "") || (e.what_will_Caregiver_do != null && e.what_will_Caregiver_do != "")))

      }

    }
    serviceplan.adLs = this.aDls;

    if (this.instrumentalActivities.length > 0) {
      if (this.instrumentalActivities.length == 1 && (this.instrumentalActivities[0].assesedNeed == null || this.instrumentalActivities[0].assesedNeed == "") && (this.instrumentalActivities[0].how_will_Caregiver_do == null || this.instrumentalActivities[0].how_will_Caregiver_do == "") && (this.instrumentalActivities[0].what_will_Caregiver_do == null || this.instrumentalActivities[0].what_will_Caregiver_do == "")) {
        this.instrumentalActivities = [];
      }
      else {
        this.instrumentalActivities = this.instrumentalActivities.filter(e => ((e.assesedNeed != null && e.assesedNeed != "") || (e.how_will_Caregiver_do != null && e.how_will_Caregiver_do != "") || (e.what_will_Caregiver_do != null && e.what_will_Caregiver_do != "")))

      }

    }
    serviceplan.instrumentalActivities = this.instrumentalActivities;


    if (this.NonMedicalEmergencies.length > 0) {
      if (this.NonMedicalEmergencies.length == 1 && (this.NonMedicalEmergencies[0].situation == null || this.NonMedicalEmergencies[0].situation == "") && (this.NonMedicalEmergencies[0].special_Instructions == null || this.NonMedicalEmergencies[0].special_Instructions == "")) {
        this.NonMedicalEmergencies = [];
      }
      else {
        this.NonMedicalEmergencies = this.NonMedicalEmergencies.filter(e => ((e.situation != null && e.situation != "") || (e.special_Instructions != null && e.special_Instructions != "")))

      }

    }
    serviceplan.nonMedicalEmergencies = this.NonMedicalEmergencies;


    if (this.behaviours.length > 0) {
      if (this.behaviours.length == 1 && (this.behaviours[0].it_means == null || this.behaviours[0].it_means == "") && (this.behaviours[0].when_I_do == null || this.behaviours[0].when_I_do == "") && (this.behaviours[0].worker_can_help_by == null || this.behaviours[0].worker_can_help_by == "")) {
        this.behaviours = [];
      }
      else {
        this.behaviours = this.behaviours.filter(e => ((e.it_means != null && e.it_means != "") || (e.when_I_do != null && e.when_I_do != "") || (e.worker_can_help_by != null && e.worker_can_help_by != "")))

      }

    }
    serviceplan.behaviours = this.behaviours;


    if (this.healthProcedures.length > 0) {
      if (this.healthProcedures.length == 1 && (this.healthProcedures[0].how_will_worker_do == null || this.healthProcedures[0].how_will_worker_do == "") && (this.healthProcedures[0].need == null || this.healthProcedures[0].need == "") && (this.healthProcedures[0].what_will_worker_do == null || this.healthProcedures[0].what_will_worker_do == "")) {
        this.healthProcedures = [];
      }
      else {
        this.healthProcedures = this.healthProcedures.filter(e => ((e.how_will_worker_do != null && e.how_will_worker_do != "") || (e.need != null && e.need != "") || (e.what_will_worker_do != null && e.what_will_worker_do != "")))


      }

    }
    serviceplan.healthProcedures = this.healthProcedures;

    if (this.classes.length > 0) {
      if (this.classes.length == 1 && (this.classes[0].className == null || this.classes[0].className == "") && (this.classes[0].cost == null || this.classes[0].cost == 0) && (this.classes[0].trainingProvider == null || this.classes[0].trainingProvider == "")) {
        this.classes = [];
      }
      else {
        this.classes = this.classes.filter(e => ((e.className != null && e.className != "") || (e.cost != null && e.cost != 0) || (e.trainingProvider != null && e.trainingProvider != "")))

        this.classes.forEach(i => {
          i.cost = (i.cost != null && i.cost != undefined && i.cost) ? parseFloat(i.cost.toString()) : 0;

        })
      }

    }
    serviceplan.classes = this.classes;
    // if (this.classes.length > 0) {
    //   if (this.classes.length == 1 && this.classes[0].className == null && this.classes[0].cost == null && this.classes[0].trainingProvider == null) {
    //     this.classes = [];
    //   }
    //   else {
    //     this.classes = this.classes.filter(e => (e.className != null || e.cost != null || e.trainingProvider != null))

    //     this.classes.forEach(i => {
    //       i.cost = (i.cost != null && i.cost != undefined && i.cost) ? parseFloat(i.cost.toString()) : null;

    //     })
    //   }

    // }
    if (serviceplan.providers.length > 0) {
      if (serviceplan.providers.length == 1 && (serviceplan.providers[0].phoneNumber == null || serviceplan.providers[0].phoneNumber == "") && (serviceplan.providers[0].address == null || serviceplan.providers[0].address == "") && (serviceplan.providers[0].providerName == null || serviceplan.providers[0].providerName == "") && (serviceplan.providers[0].specialty == null || serviceplan.providers[0].specialty == "")) {
        serviceplan.providers = [];
      }
      else {
        serviceplan.providers = serviceplan.providers.filter(e => ((e.phoneNumber != "" && e.phoneNumber != null) || (e.address != null && e.address != "") || (e.providerName != null && e.providerName != "") || (e.specialty != null && e.specialty != "")))


      }

    }
    if (serviceplan.medicalEmergencies.length > 0) {
      if (serviceplan.medicalEmergencies.length == 1 && (serviceplan.medicalEmergencies[0].if_this_happens == null || serviceplan.medicalEmergencies[0].if_this_happens == "") && (serviceplan.medicalEmergencies[0].contact == null || serviceplan.medicalEmergencies[0].contact == "") && (serviceplan.medicalEmergencies[0].specialInstructions == null || serviceplan.medicalEmergencies[0].specialInstructions == "")) {
        serviceplan.medicalEmergencies = [];
      }
      else {
        serviceplan.medicalEmergencies = serviceplan.medicalEmergencies.filter(e => ((e.if_this_happens != null && e.if_this_happens != "") || (e.contact != null && e.contact != "") || (e.specialInstructions != null && e.specialInstructions != "")))


      }

    }
    if (serviceplan.interpreters.length > 0) {
      if (serviceplan.interpreters.length == 1 && (serviceplan.interpreters[0].name == null || serviceplan.interpreters[0].name == "") && (serviceplan.interpreters[0].phonenumer == null || serviceplan.interpreters[0].phonenumer == "") && (serviceplan.interpreters[0].relationShip == null || serviceplan.interpreters[0].relationShip == "")) {
        serviceplan.interpreters = [];
      }
      else {
        serviceplan.interpreters = serviceplan.interpreters.filter(e => ((e.name != null && e.name != "") || (e.phonenumer != null && e.phonenumer != "") || (e.relationShip != null && e.relationShip != "")))


      }

    }
    if (serviceplan.careCoordinator.length > 0) {
      if (serviceplan.careCoordinator.length == 1 && (serviceplan.careCoordinator[0].coordinator_Name == null || serviceplan.careCoordinator[0].coordinator_Name == "") && (serviceplan.careCoordinator[0].coordinator_Name == null || serviceplan.careCoordinator[0].coordinator_Name == "") && (serviceplan.careCoordinator[0].email == null || serviceplan.careCoordinator[0].email == "")
        && (serviceplan.careCoordinator[0].fax == null || serviceplan.careCoordinator[0].fax == "") && (serviceplan.careCoordinator[0].state == null || serviceplan.careCoordinator[0].state == "") && (serviceplan.careCoordinator[0].city == null || serviceplan.careCoordinator[0].city == "") && (serviceplan.careCoordinator[0].street == null || serviceplan.careCoordinator[0].street == "") && (serviceplan.careCoordinator[0].zipCode == null || serviceplan.careCoordinator[0].zipCode == "")
      ) {
        serviceplan.careCoordinator = [];
      }
      else {
        serviceplan.careCoordinator = serviceplan.careCoordinator.filter(e => ((e.coordinator_Name != null && e.coordinator_Name != "") || (e.phoneNumber != null && e.phoneNumber != "") || (e.city != null && e.city != "") || (e.state != null && e.state != "") || (e.email != null && e.email != "") || (e.fax != null && e.fax != "")
          || (e.street != null && e.street != "") || (e.zipCode != "" && e.zipCode != null)
        ))


      }

    }

    if (serviceplan.participantRepresentative.length > 0) {
      if (serviceplan.participantRepresentative.length == 1 && (serviceplan.participantRepresentative[0].firstName == null || serviceplan.participantRepresentative[0].firstName == "") && (serviceplan.participantRepresentative[0].lastName == null || serviceplan.participantRepresentative[0].lastName == "") && (serviceplan.participantRepresentative[0].address == null || serviceplan.participantRepresentative[0].address == "")
        && (serviceplan.participantRepresentative[0].city == null || serviceplan.participantRepresentative[0].city == "") && (serviceplan.participantRepresentative[0].email == null || serviceplan.participantRepresentative[0].email == "") && (serviceplan.participantRepresentative[0].phoneNumber == null || serviceplan.participantRepresentative[0].phoneNumber == "")
        && (serviceplan.participantRepresentative[0].state == null || serviceplan.participantRepresentative[0].state == "") && (serviceplan.participantRepresentative[0].zipCode == null || serviceplan.participantRepresentative[0].zipCode == "")
      ) {
        serviceplan.participantRepresentative = [];
      }
      else {
        serviceplan.participantRepresentative = serviceplan.participantRepresentative.filter(e => ((e.firstName != null && e.firstName != "") || (e.lastName != null && e.lastName != "") || (e.phoneNumber != null && e.phoneNumber != "") || (e.address != null && e.address != "") || (e.city != null && e.city != "") || (e.email != null || e.email != ""
        ) || (e.state != null || e.state != "") || (e.zipCode != null || e.zipCode != "")
        ))


      }

    }

    if (serviceplan.agencyModels?.agencyDetails.length > 0) {
      if (serviceplan.agencyModels.agencyDetails.length == 1 && (serviceplan.agencyModels.agencyDetails[0].agencyName == null || serviceplan.agencyModels.agencyDetails[0].agencyName == "") && (serviceplan.agencyModels.agencyDetails[0].contactName == null || serviceplan.agencyModels.agencyDetails[0].contactName == "") && (serviceplan.agencyModels.agencyDetails[0].street == null || serviceplan.agencyModels.agencyDetails[0].street == "")
        && (serviceplan.agencyModels.agencyDetails[0].city == null || serviceplan.agencyModels.agencyDetails[0].city == "") && (serviceplan.agencyModels.agencyDetails[0].emailAddress == null || serviceplan.agencyModels.agencyDetails[0].emailAddress == "") && (serviceplan.agencyModels.agencyDetails[0].phoneNumber == null || serviceplan.agencyModels.agencyDetails[0].phoneNumber == "")
        && (serviceplan.agencyModels.agencyDetails[0].state == null || serviceplan.agencyModels.agencyDetails[0].state == "") && (serviceplan.agencyModels.agencyDetails[0].zipCode == null || serviceplan.agencyModels.agencyDetails[0].zipCode == "")
      ) {
        serviceplan.agencyModels.agencyDetails = [];
      }
      else {
        serviceplan.agencyModels.agencyDetails = serviceplan.agencyModels.agencyDetails.filter(e => ((e.agencyName != null && e.agencyName != "") || (e.contactName != null && e.contactName != "") || (e.phoneNumber != null && e.phoneNumber != "") || (e.state != null && e.state != "") || (e.city != null && e.city != "") || (e.emailAddress != null && e.emailAddress != "")
          || (e.street != null && e.street != "") || (e.zipCode != null && e.zipCode != "")
        ))


      }

    }
    if (serviceplan.fmsBudget?.workerBudgets.length > 0) {
      if (serviceplan.fmsBudget.workerBudgets.length == 1 && (serviceplan.fmsBudget.workerBudgets[0].hourly_Wage == null || serviceplan.fmsBudget.workerBudgets[0].hourly_Wage == 0) && (serviceplan.fmsBudget.workerBudgets[0].is_PTO_Applied == null) && serviceplan.fmsBudget.workerBudgets[0].is_Payroll_Applied == null
        && serviceplan.fmsBudget.workerBudgets[0].is_Worker_Comp_Applied == null && (serviceplan.fmsBudget.workerBudgets[0].no_Of_Hours_Per_Week == null || serviceplan.fmsBudget.workerBudgets[0].no_Of_Hours_Per_Week == 0) && (serviceplan.fmsBudget.workerBudgets[0].no_Of_Weeks == null || serviceplan.fmsBudget.workerBudgets[0].no_Of_Weeks == 0) && (serviceplan.fmsBudget.workerBudgets[0].totalCost == null || serviceplan.fmsBudget.workerBudgets[0].totalCost == 0)
        && (serviceplan.fmsBudget.workerBudgets[0].worker_Name == null || serviceplan.fmsBudget.workerBudgets[0].worker_Name == "")
      ) {
        serviceplan.fmsBudget.workerBudgets = [];
      }
      else {
        serviceplan.fmsBudget.workerBudgets = serviceplan.fmsBudget.workerBudgets.filter(e => ((e.hourly_Wage != null && e.hourly_Wage != 0) || (e.is_PTO_Applied != null) || e.is_Payroll_Applied != null || e.is_Worker_Comp_Applied != null || (e.no_Of_Hours_Per_Week != null && e.no_Of_Hours_Per_Week != 0) || (e.no_Of_Weeks != null && e.no_Of_Weeks != 0)
          || (e.totalCost != null && e.totalCost != 0) || (e.worker_Name != null && e.worker_Name != "")
        ))


        serviceplan.fmsBudget.workerBudgets.forEach(i => {
          i.hourly_Wage = (i.hourly_Wage != null && i.hourly_Wage != undefined && i.hourly_Wage != 0) ? parseFloat(i.hourly_Wage.toString()) : 0;
          i.no_Of_Hours_Per_Week = (i.no_Of_Hours_Per_Week != null && i.no_Of_Hours_Per_Week != undefined && i.no_Of_Hours_Per_Week != 0) ? parseFloat(i.no_Of_Hours_Per_Week.toString()) : 0;
          i.no_Of_Weeks = (i.no_Of_Weeks != null && i.no_Of_Weeks != undefined && i.no_Of_Weeks != 0) ? parseFloat(i.no_Of_Weeks.toString()) : 0;
          i.totalCost = (i.totalCost != null && i.totalCost != undefined && i.totalCost != 0) ? parseFloat(i.totalCost.toString()) : 0;
          i.percentageRate = (i.percentageRate != null && i.percentageRate != undefined && i.percentageRate != 0) ? parseFloat(i.percentageRate.toString()) : 0;

        })


      }

    }

    if (serviceplan.fmsBudget?.workerTasks.length > 0) {
      if (serviceplan.fmsBudget.workerTasks.length == 1 && (serviceplan.fmsBudget.workerTasks[0].qualifications == null || serviceplan.fmsBudget.workerTasks[0].qualifications == "") && (serviceplan.fmsBudget.workerTasks[0].task == null || serviceplan.fmsBudget.workerTasks[0].task == "")
      ) {
        serviceplan.fmsBudget.workerTasks = [];
      }
      else {
        serviceplan.fmsBudget.workerTasks = serviceplan.fmsBudget.workerTasks.filter(e => ((e.qualifications != null && e.qualifications != "") || (e.task != null && e.task != "")

        ))




      }

    }
    if (serviceplan.agencyModels?.monthlyUnitUsage?.totalUnitsUsed != null && serviceplan.agencyModels?.monthlyUnitUsage?.totalUnitsUsed != 0) {
      serviceplan.agencyModels.monthlyUnitUsage.totalUnitsUsed = Number(serviceplan.agencyModels.monthlyUnitUsage.totalUnitsUsed)
    }
    if (serviceplan.agencyModels?.monthlyUnitUsage?.unitsJan != null && serviceplan.agencyModels?.monthlyUnitUsage?.unitsJan != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsJan.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsJan = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsJan)
    }

    if (serviceplan.agencyModels?.monthlyUnitUsage?.unitsFeb != null && serviceplan.agencyModels?.monthlyUnitUsage?.unitsFeb != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsFeb.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsFeb = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsFeb)
    }

    if (serviceplan.agencyModels?.monthlyUnitUsage.unitsMar != null && serviceplan.agencyModels?.monthlyUnitUsage.unitsMar != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsMar.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsMar = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsMar)
    }
    if (serviceplan.agencyModels?.monthlyUnitUsage.unitsApr != null && serviceplan.agencyModels?.monthlyUnitUsage.unitsApr != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsApr.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsApr = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsApr)
    }

    if (serviceplan.agencyModels?.monthlyUnitUsage.unitsMay != null && serviceplan.agencyModels?.monthlyUnitUsage.unitsMay != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsMay.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsMay = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsMay)
    }


    if (serviceplan.agencyModels?.monthlyUnitUsage.unitsJun != null && serviceplan.agencyModels?.monthlyUnitUsage.unitsJun != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsJun.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsJun = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsJun)
    }

    if (serviceplan.agencyModels?.monthlyUnitUsage.unitsJul != null && serviceplan.agencyModels?.monthlyUnitUsage.unitsJul != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsJul.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsJul = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsJul)
    }
    if (serviceplan.agencyModels?.monthlyUnitUsage.unitsAug != null && serviceplan.agencyModels?.monthlyUnitUsage.unitsAug != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsAug.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsAug = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsAug)
    }
    if (serviceplan.agencyModels?.monthlyUnitUsage.unitsSep != null && serviceplan.agencyModels?.monthlyUnitUsage.unitsSep != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsSep.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsSep = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsSep)
    }
    if (serviceplan.agencyModels?.monthlyUnitUsage.unitsOct != null && serviceplan.agencyModels?.monthlyUnitUsage.unitsOct != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsOct.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsOct = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsOct)
    }
    if (serviceplan.agencyModels?.monthlyUnitUsage.unitsNov != null && serviceplan.agencyModels?.monthlyUnitUsage.unitsNov != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsNov.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsNov = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsNov)
    }
    if (serviceplan.agencyModels?.monthlyUnitUsage.unitsDec != null && serviceplan.agencyModels?.monthlyUnitUsage.unitsDec != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsDec.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsDec = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsDec)
    }
    
    serviceplan.fmsProvider = this.FMSProvider;
    serviceplan.fmsProvider.providerKeyValue = null;
    serviceplan.mhcpCost.equipment_Cost = (serviceplan.mhcpCost.equipment_Cost != null && serviceplan.mhcpCost.equipment_Cost != 0) ? Number(serviceplan.mhcpCost.equipment_Cost) : 0
    serviceplan.mhcpCost.installation_Cost = (serviceplan.mhcpCost.installation_Cost != null && serviceplan.mhcpCost.installation_Cost != 0) ? Number(serviceplan.mhcpCost.installation_Cost) : 0
    serviceplan.mhcpCost.subscription_Cost = (serviceplan.mhcpCost.subscription_Cost != null && serviceplan.mhcpCost.subscription_Cost != 0) ? Number(serviceplan.mhcpCost.subscription_Cost) : 0

    serviceplan.clientId = this.servicePlan.clientId
    serviceplan.personDob = (this.clientdob != null && this.clientdob != undefined && this.clientdob != '' && this.clientdob != null) ? this.global.getDateTimeString(this.clientdob) : null;

    serviceplan.plandate = (serviceplan.plandate != null && serviceplan.plandate != undefined && serviceplan.plandate != '' && serviceplan.plandate != null) ? this.global.getDateTimeString(serviceplan.plandate) : null;
    serviceplan.startdate = (serviceplan.startdate != null && serviceplan.startdate != undefined && serviceplan.startdate != '' && serviceplan.startdate != null) ? this.global.getDateTimeString(serviceplan.startdate) : null;
    serviceplan.enddate = (serviceplan.enddate != null && serviceplan.enddate != undefined && serviceplan.enddate != '' && serviceplan.enddate != null) ? this.global.getDateTimeString(serviceplan.enddate) : null;
    serviceplan.leadSignDate = (serviceplan.leadSignDate != null && serviceplan.leadSignDate != undefined && serviceplan.leadSignDate != '' && serviceplan.leadSignDate != null) ? this.global.getDateTimeString(serviceplan.leadSignDate) : null;
    serviceplan.providerSignDate = (serviceplan.providerSignDate != null && serviceplan.providerSignDate != undefined && serviceplan.providerSignDate != '' && serviceplan.providerSignDate != null) ? this.global.getDateTimeString(serviceplan.providerSignDate) : null;
    serviceplan.personSignDate = (serviceplan.personSignDate != null && serviceplan.personSignDate != undefined && serviceplan.personSignDate != '' && serviceplan.personSignDate != null) ? this.global.getDateTimeString(serviceplan.personSignDate) : null;
    serviceplan.parentalSignDate = (serviceplan.parentalSignDate != null && serviceplan.parentalSignDate != undefined && serviceplan.parentalSignDate != '' && serviceplan.parentalSignDate != null) ? this.global.getDateTimeString(serviceplan.parentalSignDate) : null;

    serviceplan.clientInfoDob = (serviceplan.clientInfoDob != null && serviceplan.clientInfoDob != undefined && serviceplan.clientInfoDob != '' && serviceplan.clientInfoDob != null) ? this.global.getDateTimeString(serviceplan.clientInfoDob) : null;
serviceplan.revisionDate = (serviceplan.revisionDate != null && serviceplan.revisionDate != undefined && serviceplan.revisionDate != '') ? this.global.getDateTimeString(serviceplan.revisionDate) : null;
    serviceplan.signatureBOs = [];
    if (this.parent_sign != null && this.parent_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.parent_sign;
      Bo.fileName = "PARENTSIGN";
      serviceplan.signatureBOs.push(Bo)
    }
    if (this.provider_sign != null && this.provider_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.provider_sign;
      Bo.fileName = "PROVIDERSIGN";
      serviceplan.signatureBOs.push(Bo)
    } if (this.agencystaff_sign != null && this.agencystaff_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.agencystaff_sign;
      Bo.fileName = "LEADAGENCYSIGN";
      serviceplan.signatureBOs.push(Bo)
    }
    if (this.personwhoaccess_sign != null && this.personwhoaccess_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.personwhoaccess_sign;
      Bo.fileName = "PERSONSIGN";
      serviceplan.signatureBOs.push(Bo)
      
    }
    serviceplan.signatureBOs = serviceplan.signatureBOs.filter(e => (e.signatureFileString != null && e.signatureFileString != null))

    serviceplan.parentalSignFilePath = this.parent_sign;
    serviceplan.providerSignFilePath = this.provider_sign;
    serviceplan.leadSignFilePath = this.agencystaff_sign;
    serviceplan.personSignFilePath = this.personwhoaccess_sign;
    serviceplan.totalCFSSUnitsEligible = (serviceplan?.totalCFSSUnitsEligible != null && serviceplan?.totalCFSSUnitsEligible != undefined && serviceplan?.totalCFSSUnitsEligible != 0) ? Number(serviceplan.totalCFSSUnitsEligible) : 0
    serviceplan.fmsBudget.budgetAmount = (serviceplan?.fmsBudget?.budgetAmount != null && serviceplan?.fmsBudget?.budgetAmount != undefined && serviceplan?.fmsBudget?.budgetAmount != 0) ? Number(serviceplan?.fmsBudget?.budgetAmount) : 0
    serviceplan.fmsBudget.fmsFee = (serviceplan?.fmsBudget?.fmsFee != null && serviceplan?.fmsBudget?.fmsFee != undefined && serviceplan.fmsBudget.fmsFee != 0) ? Number(serviceplan?.fmsBudget?.fmsFee) : 0
    serviceplan.fmsBudget.planMonths = (serviceplan?.fmsBudget?.planMonths != null && serviceplan?.fmsBudget?.planMonths != undefined && serviceplan.fmsBudget?.planMonths != 0) ? Number(serviceplan?.fmsBudget?.planMonths) : 0
    serviceplan.agencyModels.plannedUnits = (serviceplan?.agencyModels?.plannedUnits != null && serviceplan?.agencyModels?.plannedUnits != undefined && serviceplan.agencyModels?.plannedUnits != 0) ? Number(serviceplan?.agencyModels?.plannedUnits) : 0


    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_ServiceDeliveryPlan/SaveAndUpdateServiceDeliveryPlan";
      }
      else{

         url = "api/ServiceDeliveryPlan/SaveAndUpdateServiceDeliveryPlan";
      } 
      
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(serviceplan, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
     
     
      //====================== sucess message =============
      if (serviceplan.serviceDeliveryplanId == '00000000-0000-0000-0000-000000000000' || serviceplan.serviceDeliveryplanId == undefined) {
        serviceplan.id = data;
        this.toastrService.success('Service Delivery Plan Imported Successfully');
        this.eventdisable = false;
        this.changevalue = false;
        // this.showtable()
      }
      else if (serviceplan.serviceDeliveryplanId != '00000000-0000-0000-0000-000000000000' && serviceplan.serviceDeliveryplanId != undefined) {

        this.toastrService.success('Service Delivery Plan Updated Successfully');
       // serviceplan.id = data;
        this.servicePlan.serviceDeliveryPlanId = data;
        this.eventdisable = false;
        this.getServiceDeliverPlanDetails();
      this.changevalue = false;
      }
     // this.closeFun();
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err);
      }
      else {
        this.toastrService.error(err);
      }

    })

    // this.budgetService.savebudget(serviceplan).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

    //   if (serviceplan.id == "00000000-0000-0000-0000-000000000000") {
    //     this.toastrService.success('Service Delivery Plan Imported Successfully');
    //   }
    //   else {
    //     this.toastrService.success('Service Delivery Plan Updated Successfully');
    //   }

    //   this.closeFun();
    // }, (err: any) => {

    //   this.toastrService.error(err);
    //   this.budgetImportBO.budgetStartDate = this.datepipe.transform(this.budgetImportBO.budgetStartDate, "MM/dd/yyyy")
    //   this.budgetImportBO.budgetEndDate = this.datepipe.transform(this.budgetImportBO.budgetEndDate, "MM/dd/yyyy")
    //   this.budgetImportBO.budgetdate = this.datepipe.transform(this.budgetImportBO.budgetdate, "MM/dd/yyyy")
    //   this.budgetImportBO.healthandSafetyPlanDate = this.datepipe.transform(this.budgetImportBO.healthandSafetyPlanDate, "MM/dd/yyyy")
    //   this.budgetImportBO.whatwillDoInCaseDate = this.datepipe.transform(this.budgetImportBO.whatwillDoInCaseDate, "MM/dd/yyyy")


    // })
  }
  planRate: ServicePlanRateBO = new ServicePlanRateBO();
  getAgencyServicePlanrate() {
    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_ServiceDeliveryPlan/GetServicePlanRate?";
      }
      else{

         url = "api/ServiceDeliveryPlan/GetServicePlanRate?";
      }
    let myParams = new URLSearchParams();
    // myParams.append("AgencyId", this.global.globalAgencyId)
    let param = new URLSearchParams();

    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {


      if (data != null && data != undefined && data != "") {
        this.planRate = data;
      }
      else {
        this.planRate = new ServicePlanRateBO();
      }
    });
  }


  getFmsAgencyLov() {
   
    this.fmsagecyservice.getFmslist().pipe(takeUntil(this.onDestroy$)).subscribe((data:any)=>{
     this.FmsAgencyList = data;
       console.log(this.FmsAgencyList);
    }, (err: any) => {
     if (err) {
       this.toastrService.error(err, 'Error'), 8000;
     }
   }
   )
   }
 
   getFmsAgencydetail(){
     if(this.logintype =='onboardLogin')
       {
         return;
       }
     this.fmsservice.execute(this.getfmsagency);
     this.fmsservice.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
       this.fmsdata = data;
     }
      )
   }
   onAgencySelected(selectedKey: any): void {
     const selectedAgency = this.fmsdata.result.find(
       (agency) => agency.id === selectedKey.Key
     );
     if (selectedKey.Key) {
       this.FMSProvider.npi = selectedAgency.npi;
       this.FMSProvider.phoneNumber = selectedAgency.phoneNumber;
       this.FMSProvider.city = selectedAgency.city
       this.FMSProvider.address = selectedAgency.address;
       this.FMSProvider.state = selectedAgency.state;
       this.FMSProvider.zipCode = selectedAgency.zipCode;
       this.FMSProvider.contactName = selectedAgency.contactName;
       this.FMSProvider.email = selectedAgency.email;
       this.FMSProvider.fax = selectedAgency.fax;
       this.serviceplanImportBO.fmsBudget.fmsFee = selectedAgency.fmsFee
     }
   }
   onClear(){
     this.FMSProvider.npi = ''
     this.FMSProvider.phoneNumber = ''
     this.FMSProvider.city = ''
     this.FMSProvider.address =''
     this.FMSProvider.state = ''
     this.FMSProvider.zipCode = ''
     this.FMSProvider.contactName = ''
     this.FMSProvider.email = ''
     this.FMSProvider.fax = ''
     this.serviceplanImportBO.fmsBudget.fmsFee = 0 ;
   }
   
 
   getconsultantcontactname() {
     if(this.logintype =='onboardLogin')
     {
       return;
     }
     let url = "api/EmployeeClientMapping/getLastMappedActEmployee?";
     let param = new URLSearchParams();
     param.append("ClientId",this.servicePlan.clientId);
     this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
       let AgentBO: any = data;
         // this.serviceplanImportBO.consultantInfoContactName =  (this.serviceplanImportBO.consultantInfoContactName == null || this.serviceplanImportBO.consultantInfoContactName == "" || this.serviceplanImportBO.consultantInfoContactName == undefined)? AgentBO.agencyName: this.serviceplanImportBO.consultantInfoContactName ;
         // this.serviceplanImportBO.consultantInfoEmail =(this.serviceplanImportBO.consultantInfoEmail == null || this.serviceplanImportBO.consultantInfoEmail == "" || this.serviceplanImportBO.consultantInfoEmail == undefined)? AgentBO.agencyEmail: this.serviceplanImportBO.consultantInfoEmail ;
        
 
         this.serviceplanImportBO.consultantInfoContactName =   AgentBO?.value ;
         this.serviceplanImportBO.consultantInfoEmail = AgentBO?.email;
        
    
     },(err:any)=>
     {
       if (err) {
         this.toastrService.error(err, 'Error'), 8000;
       }
     })
   }

 



  CopyServicedeliveryplan() {

    let serviceplan: ServiceDeliveryPlan = JSON.parse(JSON.stringify(this.serviceplanImportBO));


    if (this.goodsAndServices.length > 0) {
      if (this.goodsAndServices.length == 1 && (this.goodsAndServices[0].goods_Or_Service == null || this.goodsAndServices[0].goods_Or_Service == "") && (this.goodsAndServices[0].cost == null || this.goodsAndServices[0].cost == 0)) {
        this.goodsAndServices = [];
      }
      else {
        this.goodsAndServices = this.goodsAndServices.filter(e => (e.goods_Or_Service != null && e.goods_Or_Service != "") || (e.cost != null && e.cost != 0))
        this.goodsAndServices.forEach(i => {

          if (i.cost != null && i.cost != undefined && i.cost != 0) {
            i.cost = parseFloat(i.cost.toString())
          }
          else {

            i.cost = 0
          }

          i.fms_Fee_Percentage = (i.fms_Fee_Percentage != null && i.fms_Fee_Percentage != undefined && i.fms_Fee_Percentage != 0) ? parseFloat(i.fms_Fee_Percentage.toString()) : null;
          i.id = "00000000-0000-0000-0000-000000000000";
        })


      }

    }
    serviceplan.goodsAndServices = this.goodsAndServices;

    if (this.aDls.length > 0) {
      if (this.aDls.length == 1 && (this.aDls[0].assesedNeed == "" || this.aDls[0].assesedNeed == null) && (this.aDls[0].fromWhom == "" || this.aDls[0].fromWhom == null)) {
        this.aDls = [];
      }
      else {
        this.aDls = this.aDls.filter(e => ((e.assesedNeed != null && e.assesedNeed != "") || (e.fromWhom != null && e.fromWhom != "") || (e.how_will_Caregiver_do != null && e.how_will_Caregiver_do != "") || (e.what_will_Caregiver_do != null && e.what_will_Caregiver_do != "")))
        this.aDls.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });

      }

    }
    serviceplan.adLs = this.aDls;

    if (this.instrumentalActivities.length > 0) {
      if (this.instrumentalActivities.length == 1 && (this.instrumentalActivities[0].assesedNeed == null || this.instrumentalActivities[0].assesedNeed == "") && (this.instrumentalActivities[0].how_will_Caregiver_do == null || this.instrumentalActivities[0].how_will_Caregiver_do == "") && (this.instrumentalActivities[0].what_will_Caregiver_do == null || this.instrumentalActivities[0].what_will_Caregiver_do == "")) {
        this.instrumentalActivities = [];
      }
      else {
        this.instrumentalActivities = this.instrumentalActivities.filter(e => ((e.assesedNeed != null && e.assesedNeed != "") || (e.how_will_Caregiver_do != null && e.how_will_Caregiver_do != "") || (e.what_will_Caregiver_do != null && e.what_will_Caregiver_do != "")))

        this.instrumentalActivities.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });
      }

    }
    serviceplan.instrumentalActivities = this.instrumentalActivities;


    if (this.NonMedicalEmergencies.length > 0) {
      if (this.NonMedicalEmergencies.length == 1 && (this.NonMedicalEmergencies[0].situation == null || this.NonMedicalEmergencies[0].situation == "") && (this.NonMedicalEmergencies[0].special_Instructions == null || this.NonMedicalEmergencies[0].special_Instructions == "")) {
        this.NonMedicalEmergencies = [];
      }
      else {
        this.NonMedicalEmergencies = this.NonMedicalEmergencies.filter(e => ((e.situation != null && e.situation != "") || (e.special_Instructions != null && e.special_Instructions != "")))
        this.NonMedicalEmergencies.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });
      }

    }
    serviceplan.nonMedicalEmergencies = this.NonMedicalEmergencies;


    if (this.behaviours.length > 0) {
      if (this.behaviours.length == 1 && (this.behaviours[0].it_means == null || this.behaviours[0].it_means == "") && (this.behaviours[0].when_I_do == null || this.behaviours[0].when_I_do == "") && (this.behaviours[0].worker_can_help_by == null || this.behaviours[0].worker_can_help_by == "")) {
        this.behaviours = [];
      }
      else {
        this.behaviours = this.behaviours.filter(e => ((e.it_means != null && e.it_means != "") || (e.when_I_do != null && e.when_I_do != "") || (e.worker_can_help_by != null && e.worker_can_help_by != "")))
        this.behaviours.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });
      }

    }
    serviceplan.behaviours = this.behaviours;


    if (this.healthProcedures.length > 0) {
      if (this.healthProcedures.length == 1 && (this.healthProcedures[0].how_will_worker_do == null || this.healthProcedures[0].how_will_worker_do == "") && (this.healthProcedures[0].need == null || this.healthProcedures[0].need == "") && (this.healthProcedures[0].what_will_worker_do == null || this.healthProcedures[0].what_will_worker_do == "")) {
        this.healthProcedures = [];
      }
      else {
        this.healthProcedures = this.healthProcedures.filter(e => ((e.how_will_worker_do != null && e.how_will_worker_do != "") || (e.need != null && e.need != "") || (e.what_will_worker_do != null && e.what_will_worker_do != "")))
        this.healthProcedures.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });

      }

    }
    serviceplan.healthProcedures = this.healthProcedures;

    if (this.classes.length > 0) {
      if (this.classes.length == 1 && (this.classes[0].className == null || this.classes[0].className == "") && (this.classes[0].cost == null || this.classes[0].cost == 0) && (this.classes[0].trainingProvider == null || this.classes[0].trainingProvider == "")) {
        this.classes = [];
      }
      else {
        this.classes = this.classes.filter(e => ((e.className != null && e.className != "") || (e.cost != null && e.cost != 0) || (e.trainingProvider != null && e.trainingProvider != "")))

        this.classes.forEach(i => {
          i.cost = (i.cost != null && i.cost != undefined && i.cost) ? parseFloat(i.cost.toString()) : 0;
          i.id = "00000000-0000-0000-0000-000000000000";
        })
      }

    }
    serviceplan.classes = this.classes;
    // if (this.classes.length > 0) {
    //   if (this.classes.length == 1 && this.classes[0].className == null && this.classes[0].cost == null && this.classes[0].trainingProvider == null) {
    //     this.classes = [];
    //   }
    //   else {
    //     this.classes = this.classes.filter(e => (e.className != null || e.cost != null || e.trainingProvider != null))

    //     this.classes.forEach(i => {
    //       i.cost = (i.cost != null && i.cost != undefined && i.cost) ? parseFloat(i.cost.toString()) : null;

    //     })
    //   }

    // }
    if (serviceplan.providers.length > 0) {
      if (serviceplan.providers.length == 1 && (serviceplan.providers[0].phoneNumber == null || serviceplan.providers[0].phoneNumber == "") && (serviceplan.providers[0].address == null || serviceplan.providers[0].address == "") && (serviceplan.providers[0].providerName == null || serviceplan.providers[0].providerName == "") && (serviceplan.providers[0].specialty == null || serviceplan.providers[0].specialty == "")) {
        serviceplan.providers = [];
      }
      else {
        serviceplan.providers = serviceplan.providers.filter(e => ((e.phoneNumber != "" && e.phoneNumber != null) || (e.address != null && e.address != "") || (e.providerName != null && e.providerName != "") || (e.specialty != null && e.specialty != "")))
        serviceplan.providers.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });

      }

    }
    if (serviceplan.medicalEmergencies.length > 0) {
      if (serviceplan.medicalEmergencies.length == 1 && (serviceplan.medicalEmergencies[0].if_this_happens == null || serviceplan.medicalEmergencies[0].if_this_happens == "") && (serviceplan.medicalEmergencies[0].contact == null || serviceplan.medicalEmergencies[0].contact == "") && (serviceplan.medicalEmergencies[0].specialInstructions == null || serviceplan.medicalEmergencies[0].specialInstructions == "")) {
        serviceplan.medicalEmergencies = [];
      }
      else {
        serviceplan.medicalEmergencies = serviceplan.medicalEmergencies.filter(e => ((e.if_this_happens != null && e.if_this_happens != "") || (e.contact != null && e.contact != "") || (e.specialInstructions != null && e.specialInstructions != "")))
        serviceplan.medicalEmergencies.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });


      }

    }
    if (serviceplan.interpreters.length > 0) {
      if (serviceplan.interpreters.length == 1 && (serviceplan.interpreters[0].name == null || serviceplan.interpreters[0].name == "") && (serviceplan.interpreters[0].phonenumer == null || serviceplan.interpreters[0].phonenumer == "") && (serviceplan.interpreters[0].relationShip == null || serviceplan.interpreters[0].relationShip == "")) {
        serviceplan.interpreters = [];
      }
      else {
        serviceplan.interpreters = serviceplan.interpreters.filter(e => ((e.name != null && e.name != "") || (e.phonenumer != null && e.phonenumer != "") || (e.relationShip != null && e.relationShip != "")))

        serviceplan.interpreters.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });
      }

    }
    if (serviceplan.careCoordinator.length > 0) {
      if (serviceplan.careCoordinator.length == 1 && (serviceplan.careCoordinator[0].coordinator_Name == null || serviceplan.careCoordinator[0].coordinator_Name == "") && (serviceplan.careCoordinator[0].coordinator_Name == null || serviceplan.careCoordinator[0].coordinator_Name == "") && (serviceplan.careCoordinator[0].email == null || serviceplan.careCoordinator[0].email == "")
        && (serviceplan.careCoordinator[0].fax == null || serviceplan.careCoordinator[0].fax == "") && (serviceplan.careCoordinator[0].state == null || serviceplan.careCoordinator[0].state == "") && (serviceplan.careCoordinator[0].city == null || serviceplan.careCoordinator[0].city == "") && (serviceplan.careCoordinator[0].street == null || serviceplan.careCoordinator[0].street == "") && (serviceplan.careCoordinator[0].zipCode == null || serviceplan.careCoordinator[0].zipCode == "")
      ) {
        serviceplan.careCoordinator = [];
      }
      else {
        serviceplan.careCoordinator = serviceplan.careCoordinator.filter(e => ((e.coordinator_Name != null && e.coordinator_Name != "") || (e.phoneNumber != null && e.phoneNumber != "") || (e.city != null && e.city != "") || (e.state != null && e.state != "") || (e.email != null && e.email != "") || (e.fax != null && e.fax != "")
          || (e.street != null && e.street != "") || (e.zipCode != "" && e.zipCode != null)
        ))
        serviceplan.careCoordinator.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });

      }

    }

    if (serviceplan.participantRepresentative.length > 0) {
      if (serviceplan.participantRepresentative.length == 1 && (serviceplan.participantRepresentative[0].firstName == null || serviceplan.participantRepresentative[0].firstName == "") && (serviceplan.participantRepresentative[0].lastName == null || serviceplan.participantRepresentative[0].lastName == "") && (serviceplan.participantRepresentative[0].address == null || serviceplan.participantRepresentative[0].address == "")
        && (serviceplan.participantRepresentative[0].city == null || serviceplan.participantRepresentative[0].city == "") && (serviceplan.participantRepresentative[0].email == null || serviceplan.participantRepresentative[0].email == "") && (serviceplan.participantRepresentative[0].phoneNumber == null || serviceplan.participantRepresentative[0].phoneNumber == "")
        && (serviceplan.participantRepresentative[0].state == null || serviceplan.participantRepresentative[0].state == "") && (serviceplan.participantRepresentative[0].zipCode == null || serviceplan.participantRepresentative[0].zipCode == "")
      ) {
        serviceplan.participantRepresentative = [];
      }
      else {
        serviceplan.participantRepresentative = serviceplan.participantRepresentative.filter(e => ((e.firstName != null && e.firstName != "") || (e.lastName != null && e.lastName != "") || (e.phoneNumber != null && e.phoneNumber != "") || (e.address != null && e.address != "") || (e.city != null && e.city != "") || (e.email != null || e.email != ""
        ) || (e.state != null || e.state != "") || (e.zipCode != null || e.zipCode != "")
        ))
        serviceplan.participantRepresentative.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });

      }

    }

    if (serviceplan.agencyModels?.agencyDetails.length > 0) {
      if (serviceplan.agencyModels.agencyDetails.length == 1 && (serviceplan.agencyModels.agencyDetails[0].agencyName == null || serviceplan.agencyModels.agencyDetails[0].agencyName == "") && (serviceplan.agencyModels.agencyDetails[0].contactName == null || serviceplan.agencyModels.agencyDetails[0].contactName == "") && (serviceplan.agencyModels.agencyDetails[0].street == null || serviceplan.agencyModels.agencyDetails[0].street == "")
        && (serviceplan.agencyModels.agencyDetails[0].city == null || serviceplan.agencyModels.agencyDetails[0].city == "") && (serviceplan.agencyModels.agencyDetails[0].emailAddress == null || serviceplan.agencyModels.agencyDetails[0].emailAddress == "") && (serviceplan.agencyModels.agencyDetails[0].phoneNumber == null || serviceplan.agencyModels.agencyDetails[0].phoneNumber == "")
        && (serviceplan.agencyModels.agencyDetails[0].state == null || serviceplan.agencyModels.agencyDetails[0].state == "") && (serviceplan.agencyModels.agencyDetails[0].zipCode == null || serviceplan.agencyModels.agencyDetails[0].zipCode == "")
      ) {
        serviceplan.agencyModels.agencyDetails = [];
      }
      else {
        serviceplan.agencyModels.agencyDetails = serviceplan.agencyModels.agencyDetails.filter(e => ((e.agencyName != null && e.agencyName != "") || (e.contactName != null && e.contactName != "") || (e.phoneNumber != null && e.phoneNumber != "") || (e.state != null && e.state != "") || (e.city != null && e.city != "") || (e.emailAddress != null && e.emailAddress != "")
          || (e.street != null && e.street != "") || (e.zipCode != null && e.zipCode != "")
        ))

        serviceplan.agencyModels.agencyDetails.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });
      }

    }
    if (serviceplan.fmsBudget?.workerBudgets.length > 0) {
      if (serviceplan.fmsBudget.workerBudgets.length == 1 && (serviceplan.fmsBudget.workerBudgets[0].hourly_Wage == null || serviceplan.fmsBudget.workerBudgets[0].hourly_Wage == 0) && (serviceplan.fmsBudget.workerBudgets[0].is_PTO_Applied == null) && serviceplan.fmsBudget.workerBudgets[0].is_Payroll_Applied == null
        && serviceplan.fmsBudget.workerBudgets[0].is_Worker_Comp_Applied == null && (serviceplan.fmsBudget.workerBudgets[0].no_Of_Hours_Per_Week == null || serviceplan.fmsBudget.workerBudgets[0].no_Of_Hours_Per_Week == 0) && (serviceplan.fmsBudget.workerBudgets[0].no_Of_Weeks == null || serviceplan.fmsBudget.workerBudgets[0].no_Of_Weeks == 0) && (serviceplan.fmsBudget.workerBudgets[0].totalCost == null || serviceplan.fmsBudget.workerBudgets[0].totalCost == 0)
        && (serviceplan.fmsBudget.workerBudgets[0].worker_Name == null || serviceplan.fmsBudget.workerBudgets[0].worker_Name == "")
      ) {
        serviceplan.fmsBudget.workerBudgets = [];
      }
      else {
        serviceplan.fmsBudget.workerBudgets = serviceplan.fmsBudget.workerBudgets.filter(e => ((e.hourly_Wage != null && e.hourly_Wage != 0) || (e.is_PTO_Applied != null) || e.is_Payroll_Applied != null || e.is_Worker_Comp_Applied != null || (e.no_Of_Hours_Per_Week != null && e.no_Of_Hours_Per_Week != 0) || (e.no_Of_Weeks != null && e.no_Of_Weeks != 0)
          || (e.totalCost != null && e.totalCost != 0) || (e.worker_Name != null && e.worker_Name != "")
        ))


        serviceplan.fmsBudget.workerBudgets.forEach(i => {
          i.hourly_Wage = (i.hourly_Wage != null && i.hourly_Wage != undefined && i.hourly_Wage != 0) ? parseFloat(i.hourly_Wage.toString()) : 0;
          i.no_Of_Hours_Per_Week = (i.no_Of_Hours_Per_Week != null && i.no_Of_Hours_Per_Week != undefined && i.no_Of_Hours_Per_Week != 0) ? parseFloat(i.no_Of_Hours_Per_Week.toString()) : 0;
          i.no_Of_Weeks = (i.no_Of_Weeks != null && i.no_Of_Weeks != undefined && i.no_Of_Weeks != 0) ? parseFloat(i.no_Of_Weeks.toString()) : 0;
          i.totalCost = (i.totalCost != null && i.totalCost != undefined && i.totalCost != 0) ? parseFloat(i.totalCost.toString()) : 0;
          i.percentageRate = (i.percentageRate != null && i.percentageRate != undefined && i.percentageRate != 0) ? parseFloat(i.percentageRate.toString()) : 0;
          i.id = "00000000-0000-0000-0000-000000000000";
          i.workerBudgetId = "00000000-0000-0000-0000-000000000000";

        })


      }

    }

    if (serviceplan.fmsBudget?.workerTasks.length > 0) {
      if (serviceplan.fmsBudget.workerTasks.length == 1 && (serviceplan.fmsBudget.workerTasks[0].qualifications == null || serviceplan.fmsBudget.workerTasks[0].qualifications == "") && (serviceplan.fmsBudget.workerTasks[0].task == null || serviceplan.fmsBudget.workerTasks[0].task == "")
      ) {
        serviceplan.fmsBudget.workerTasks = [];
      }
      else {
        serviceplan.fmsBudget.workerTasks = serviceplan.fmsBudget.workerTasks.filter(e => ((e.qualifications != null && e.qualifications != "") || (e.task != null && e.task != "")

        ))

        serviceplan.fmsBudget.workerTasks.forEach(element => {
          element.id = "00000000-0000-0000-0000-000000000000";
        });


      }

    }
    if (serviceplan.agencyModels.monthlyUnitUsage != null) {
      serviceplan.agencyModels.monthlyUnitUsage.id = "00000000-0000-0000-0000-000000000000";
    }

    if (serviceplan.agencyModels.monthlyUnitUsage.totalUnitsUsed != null && serviceplan.agencyModels.monthlyUnitUsage.totalUnitsUsed != 0) {
      serviceplan.agencyModels.monthlyUnitUsage.totalUnitsUsed = Number(serviceplan.agencyModels.monthlyUnitUsage.totalUnitsUsed)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsJan != null && serviceplan.agencyModels.monthlyUnitUsage.unitsJan != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsJan.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsJan = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsJan)
    }

    if (serviceplan.agencyModels.monthlyUnitUsage.unitsFeb != null && serviceplan.agencyModels.monthlyUnitUsage.unitsFeb != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsFeb.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsFeb = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsFeb)
    }

    if (serviceplan.agencyModels.monthlyUnitUsage.unitsMar != null && serviceplan.agencyModels.monthlyUnitUsage.unitsMar != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsMar.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsMar = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsMar)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsApr != null && serviceplan.agencyModels.monthlyUnitUsage.unitsApr != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsApr.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsApr = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsApr)
    }

    if (serviceplan.agencyModels.monthlyUnitUsage.unitsMay != null && serviceplan.agencyModels.monthlyUnitUsage.unitsMay != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsMay.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsMay = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsMay)
    }


    if (serviceplan.agencyModels.monthlyUnitUsage.unitsJun != null && serviceplan.agencyModels.monthlyUnitUsage.unitsJun != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsJun.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsJun = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsJun)
    }

    if (serviceplan.agencyModels.monthlyUnitUsage.unitsJul != null && serviceplan.agencyModels.monthlyUnitUsage.unitsJul != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsJul.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsJul = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsJul)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsAug != null && serviceplan.agencyModels.monthlyUnitUsage.unitsAug != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsAug.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsAug = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsAug)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsSep != null && serviceplan.agencyModels.monthlyUnitUsage.unitsSep != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsSep.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsSep = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsSep)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsOct != null && serviceplan.agencyModels.monthlyUnitUsage.unitsOct != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsOct.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsOct = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsOct)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsNov != null && serviceplan.agencyModels.monthlyUnitUsage.unitsNov != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsNov.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsNov = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsNov)
    }
    if (serviceplan.agencyModels.monthlyUnitUsage.unitsDec != null && serviceplan.agencyModels.monthlyUnitUsage.unitsDec != 0 && serviceplan.agencyModels.monthlyUnitUsage.unitsDec.toString() != "") {
      serviceplan.agencyModels.monthlyUnitUsage.unitsDec = Number(serviceplan.agencyModels.monthlyUnitUsage.unitsDec)
    }
    serviceplan.fmsProvider = this.FMSProvider;
    serviceplan.fmsProvider.id = "00000000-0000-0000-0000-000000000000";
    serviceplan.mhcpCost.equipment_Cost = (serviceplan.mhcpCost.equipment_Cost != null && serviceplan.mhcpCost.equipment_Cost != 0) ? Number(serviceplan.mhcpCost.equipment_Cost) : 0
    serviceplan.mhcpCost.installation_Cost = (serviceplan.mhcpCost.installation_Cost != null && serviceplan.mhcpCost.installation_Cost != 0) ? Number(serviceplan.mhcpCost.installation_Cost) : 0
    serviceplan.mhcpCost.subscription_Cost = (serviceplan.mhcpCost.subscription_Cost != null && serviceplan.mhcpCost.subscription_Cost != 0) ? Number(serviceplan.mhcpCost.subscription_Cost) : 0
    if (serviceplan.mhcpCost != null) {
      serviceplan.mhcpCost.id = "00000000-0000-0000-0000-000000000000";
    }
    serviceplan.clientId = this.servicePlan.clientId
    serviceplan.personDob = (this.clientdob != null && this.clientdob != undefined && this.clientdob != '' && this.clientdob != null) ? this.global.getDateTimeString(this.clientdob) : null;

    serviceplan.plandate = (serviceplan.plandate != null && serviceplan.plandate != undefined && serviceplan.plandate != '' && serviceplan.plandate != null) ? this.global.getDateTimeString(serviceplan.plandate) : null;
    serviceplan.startdate = (serviceplan.startdate != null && serviceplan.startdate != undefined && serviceplan.startdate != '' && serviceplan.startdate != null) ? this.global.getDateTimeString(serviceplan.startdate) : null;
    serviceplan.enddate = (serviceplan.enddate != null && serviceplan.enddate != undefined && serviceplan.enddate != '' && serviceplan.enddate != null) ? this.global.getDateTimeString(serviceplan.enddate) : null;
    serviceplan.leadSignDate = (serviceplan.leadSignDate != null && serviceplan.leadSignDate != undefined && serviceplan.leadSignDate != '' && serviceplan.leadSignDate != null) ? this.global.getDateTimeString(serviceplan.leadSignDate) : null;
    serviceplan.providerSignDate = (serviceplan.providerSignDate != null && serviceplan.providerSignDate != undefined && serviceplan.providerSignDate != '' && serviceplan.providerSignDate != null) ? this.global.getDateTimeString(serviceplan.providerSignDate) : null;
    serviceplan.personSignDate = (serviceplan.personSignDate != null && serviceplan.personSignDate != undefined && serviceplan.personSignDate != '' && serviceplan.personSignDate != null) ? this.global.getDateTimeString(serviceplan.personSignDate) : null;
    serviceplan.parentalSignDate = (serviceplan.parentalSignDate != null && serviceplan.parentalSignDate != undefined && serviceplan.parentalSignDate != '' && serviceplan.parentalSignDate != null) ? this.global.getDateTimeString(serviceplan.parentalSignDate) : null;

    serviceplan.clientInfoDob = (serviceplan.clientInfoDob != null && serviceplan.clientInfoDob != undefined && serviceplan.clientInfoDob != '' && serviceplan.clientInfoDob != null) ? this.global.getDateTimeString(serviceplan.clientInfoDob) : null;
serviceplan.revisionDate = (serviceplan.revisionDate != null && serviceplan.revisionDate != undefined && serviceplan.revisionDate != '') ? this.global.getDateTimeString(serviceplan.revisionDate) : null;
    serviceplan.signatureBOs = [];
    if (this.parent_sign != null && this.parent_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.parent_sign;
      Bo.fileName = "PARENTSIGN";
      serviceplan.signatureBOs.push(Bo)
    }
    if (this.provider_sign != null && this.provider_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.provider_sign;
      Bo.fileName = "PROVIDERSIGN";
      serviceplan.signatureBOs.push(Bo)
    } if (this.agencystaff_sign != null && this.agencystaff_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.agencystaff_sign;
      Bo.fileName = "LEADAGENCYSIGN";
      serviceplan.signatureBOs.push(Bo)
    }
    if (this.personwhoaccess_sign != null && this.personwhoaccess_sign != "") {
      let Bo = new SignatureBO()
      Bo.signatureFileString = this.personwhoaccess_sign;
      Bo.fileName = "PERSONSIGN";
      serviceplan.signatureBOs.push(Bo)
    }
    serviceplan.signatureBOs = serviceplan.signatureBOs.filter(e => (e.signatureFileString != null && e.signatureFileString != null))

    serviceplan.parentalSignFilePath = this.parent_sign;
    serviceplan.providerSignFilePath = this.provider_sign;
    serviceplan.leadSignFilePath = this.agencystaff_sign;
    serviceplan.personSignFilePath = this.personwhoaccess_sign;
    serviceplan.totalCFSSUnitsEligible = (serviceplan?.totalCFSSUnitsEligible != null && serviceplan?.totalCFSSUnitsEligible != undefined && serviceplan?.totalCFSSUnitsEligible != 0) ? Number(serviceplan.totalCFSSUnitsEligible) : 0
    serviceplan.fmsBudget.budgetAmount = (serviceplan?.fmsBudget?.budgetAmount != null && serviceplan?.fmsBudget?.budgetAmount != undefined && serviceplan?.fmsBudget?.budgetAmount != 0) ? Number(serviceplan?.fmsBudget?.budgetAmount) : 0
    serviceplan.fmsBudget.fmsFee = (serviceplan?.fmsBudget?.fmsFee != null && serviceplan?.fmsBudget?.fmsFee != undefined && serviceplan.fmsBudget.fmsFee != 0) ? Number(serviceplan?.fmsBudget?.fmsFee) : 0
    serviceplan.fmsBudget.planMonths = (serviceplan?.fmsBudget?.planMonths != null && serviceplan?.fmsBudget?.planMonths != undefined && serviceplan.fmsBudget?.planMonths != 0) ? Number(serviceplan?.fmsBudget?.planMonths) : 0
    serviceplan.agencyModels.plannedUnits = (serviceplan?.agencyModels?.plannedUnits != null && serviceplan?.agencyModels?.plannedUnits != undefined && serviceplan.agencyModels?.plannedUnits != 0) ? Number(serviceplan?.agencyModels?.plannedUnits) : 0
    if (this.servicePlan.copy == true) {
      serviceplan.id = '00000000-0000-0000-0000-000000000000';
      serviceplan.serviceDeliveryPlanId = '00000000-0000-0000-0000-000000000000';
    }

    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_ServiceDeliveryPlan/SaveAndUpdateServiceDeliveryPlan";
      }
      else{

         url = "api/ServiceDeliveryPlan/SaveAndUpdateServiceDeliveryPlan";
      }
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(serviceplan, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      //====================== sucess message =============
      if (serviceplan.id == '00000000-0000-0000-0000-000000000000' || serviceplan.id == undefined) {
        serviceplan.id = data;
        this.eventdisable = false;
        this.toastrService.success('Service Delivery Plan Imported Successfully');
        // this.showtable()
      }
      else if (serviceplan.id != '00000000-0000-0000-0000-000000000000' && serviceplan.id != undefined) {
        this.eventdisable = false;
        this.toastrService.success('Service Delivery Plan Updated Successfully');
      }
      this.closeFun();
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err);
      }
      else {
        this.toastrService.error(err);
      }

    })

    // this.budgetService.savebudget(serviceplan).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

    //   if (serviceplan.id == "00000000-0000-0000-0000-000000000000") {
    //     this.toastrService.success('Service Delivery Plan Imported Successfully');
    //   }
    //   else {
    //     this.toastrService.success('Service Delivery Plan Updated Successfully');
    //   }

    //   this.closeFun();
    // }, (err: any) => {

    //   this.toastrService.error(err);
    //   this.budgetImportBO.budgetStartDate = this.datepipe.transform(this.budgetImportBO.budgetStartDate, "MM/dd/yyyy")
    //   this.budgetImportBO.budgetEndDate = this.datepipe.transform(this.budgetImportBO.budgetEndDate, "MM/dd/yyyy")
    //   this.budgetImportBO.budgetdate = this.datepipe.transform(this.budgetImportBO.budgetdate, "MM/dd/yyyy")
    //   this.budgetImportBO.healthandSafetyPlanDate = this.datepipe.transform(this.budgetImportBO.healthandSafetyPlanDate, "MM/dd/yyyy")
    //   this.budgetImportBO.whatwillDoInCaseDate = this.datepipe.transform(this.budgetImportBO.whatwillDoInCaseDate, "MM/dd/yyyy")


    // })
  }
  eventdisable: boolean = false;
  EventButtonDisable() {
  

    //   new Date(this.serviceplanImportBO.enddate).getDate() !== new Date(this.servicePlan.endDate).getDate() ||
    //   new Date(this.serviceplanImportBO.plandate).getDate() !== new Date(this.servicePlan.planDate).getDate(), "uuuuu");

    if (new Date(this.serviceplanImportBO.startdate).getDate() !== new Date(this.servicePlan.startdate).getDate() ||
      new Date(this.serviceplanImportBO.enddate).getDate() !== new Date(this.servicePlan.enddate).getDate() ||
      new Date(this.serviceplanImportBO.plandate).getDate() !== new Date(this.servicePlan.plandate).getDate() ||
      this.serviceplanImportBO.modelTypename !== this.servicePlan.modelTypename
       
      // this.serviceplanImportBO.version!= this.servicePlan.version  
    ) {
      this.eventdisable = true;
    }
    else {
      this.eventdisable = false;
    }
  }


  createEvents() {

    let serviceplan: ServiceDeliveryPlan = JSON.parse(JSON.stringify(this.serviceplanImportBO));

    let url = "api/ServiceDeliveryPlan/CreateEventsForSDP?";

    let params = new URLSearchParams();
    params.append("Id",  this.servicePlan.serviceDeliveryPlanId);

    this.CommonAPI.saveorUpdateFunctionwithParams(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
     this.GridDataEvent = data;
     this.GridDataEvent.forEach(event => {
          event.getConfirmation = true;
          event.isCheckboxDisabled = false;
          event.noCallMessage = '';
          this.OutBoundCall(event, event.startTime, event.endTime);
         })
         if (!this.GridDataEvent || this.GridDataEvent.length === 0) {
          this.addEvent(); 
        }
      
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err);
      }
      else {
        this.toastrService.error(err);
      }

    })


  }
  getLanguageList() {
    let url = "api/Language/GetLanguageList";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson("", url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.languageList = data;
          this.languageList.forEach(element => {
            element.id = element.id.toString()
          });
        },
        (err: any) => {
          this.toastrService.error(err);
        }
      );
  }
  removeEvent(index: number) {
    if (this.GridDataEvent.length > 1) {
        this.GridDataEvent.splice(index, 1);
    }
}
GetUserDropDownList() {
  this.EventService.GetUserDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    this.UserDropDownList = data;
  },
    (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
}
GetStatusLovDropDown() {
  let params = new URLSearchParams();
  params.append("ListCode", "EVENTSTATUS");
  this.EventService.getLovValues(params).subscribe((data: any) => {
    this.StatusList=data
 
  })
}
addEvent() {
  if (!this.GridDataEvent || this.GridDataEvent.length === 0){
    this.GridDataEvent.push({
      clientName: this.clientname,
      consultantId: null,
      startTime: null,
      endTime: null,
      eventTitle: '',
      eventDescription: '',
      statusLid: null,
      cfssModel: this.serviceplanImportBO.modelTypename,
      languageListIds: [],
      typeofContactId: null,
      typeofServiceId: null,
      eventAlterList: [],
      isInvalid: false,
      isOverlapping: false,
      clientId : this.global.clientId,
      serviceDeliveryPlanId : this.servicePlan.serviceDeliveryPlanId,
      getConfirmation: true,
      isCheckboxDisabled: false,
      noCallMessage: ''
    });
  }
  else{
    this.GridDataEvent.push({
      ...this.GridDataEvent[0], 
      startTime: '',  
      endTime: ''   ,
      eventDescription : ''  ,
      getConfirmation: true ,
      isCheckboxDisabled: false,
      noCallMessage: ''
  });
  }

}
submitted = false;
validateGridDataEvent() {
  const isInvalid = this.GridDataEvent?.some((item: any) => {
    const start = new Date(item?.startTime);
    const end = new Date(item?.endTime);
    if (start?.toDateString() !== end?.toDateString()) {
      return true; 
    }
  });
  if (isInvalid) {
    this.toastrService.error("Start and End date must be on the same day.");
    return false;
  }
  return true;
}
saveEvent(){
  this.submitted = true;
  if (!this.validateGridDataEvent()) {
    return;
  }
  this.submitted = true;
  // Check if all required fields are filled
  const isValid = this.GridDataEvent?.every(event => 
      event?.consultantId && event?.startTime && event?.endTime && event?.eventTitle && event?.statusLid
  );

  if (!isValid) {
    this.toastrService.error("Please Fill all Mandatory Field")
    return;
}
  let url = "api/Event/SaveEventList";
  this.CommonAPI
    .saveorUpdateFunctionwithResponseTypeText(this.GridDataEvent, url)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe(
      (data) => {
        this.toastrService.success("Events created Successfully")
        this.isevent = true;
        document.getElementById('createeventTrigger').click();
      },
      (err: any) => {
        this.toastrService.error(err);
      }
    );
}
GetLovDropDown() {
  let params = new URLSearchParams();
  params.append("ListCode", "EVENTALERT");

  this.EventService.getLovValues(params).subscribe((data: any) => {
    this.EventList = data?.map(element => ({
      eventAlertId: element.id,
      eventAlterName: element.lovName,  


      eventAlertValue: element.lovValue,
      id: element.id,
      isCheck: true
    }));
    const defaultEvent = this.EventList.find(e => e.eventAlterName === "1 hour before").eventAlertId;

    this.GridDataEvent?.forEach(event => {
      event.eventAlterList = defaultEvent ? [defaultEvent] : [];
    });
  });
}



updateSelectedEventAlerts(event) {
  event.eventAlterList = event?.eventAlterList.map(eventId => {
    let selectedEvent = this.EventList?.find(e => e.eventAlertId === eventId);
    if (selectedEvent) {
      return { ...selectedEvent, isCheck: true }; 
    }
    return {};
  });
}

compareEventAlerts(event1: any, event2: any): boolean {
  return event1 && event2 ? event1.eventAlertId === event2.eventAlertId : event1 === event2;
}

sendEventdata(){
  this.eventdata.startDate = this.serviceplanImportBO.startdate;
  this.eventdata.endDate = this.serviceplanImportBO.enddate;
  this.eventdata.clientId = this.serviceplanImportBO.clientId;
  this.eventdata.serviceDeliveryPlanId = this.servicePlan.serviceDeliveryPlanId;
  this.eventdata.isedit = true;
  this.global.isSDPtoEvent = true;
  this.eventsShare.updateFilterData(this.eventdata)
  document.getElementById('manageeventTrigger').click();
}
GetContactType() {
  let params = new URLSearchParams();
  params.append("ListCode", "SESSIONCONTACTTYPE");
  this.EventService.getLovValues(params).subscribe((data: any) => {
    this.ContactList = data;
  })
}
async GetServiceType(): Promise<void> {
  return new Promise((resolve, reject) => {
    // if (this.saveBo.clientId != null && this.saveBo.clientId != undefined) {
      let params = new URLSearchParams();
      // params.append("ClientId", this.saveBo.clientId)
      this.CSService.getServiceValues(params).subscribe((data: any) => {
        this.ServiceList = data;
        
        resolve(data);
        // if (this.ServiceList.length == 0) {
        //   this.saveBo.typeofServiceId = null;
        // }
        // else{
        //   this.saveBo.typeofServiceId= this.saveBo.typeofServiceId;
        // }
      })
      resolve();
      this.ServiceList = [];
  });
}

validateEventTimes() {
  this.GridDataEvent.forEach((event, index) => {
    // Ensure startTime and endTime are valid dates
    if (!event.startTime || !event.endTime) {
      event.isInvalid = true; // Flag invalid event
      return;
    }

    const startTime = new Date(event.startTime).getTime();
    const endTime = new Date(event.endTime).getTime();

    // Check if end time is greater than start time
    event.isInvalid = endTime <= startTime;

    // Check for overlapping events
    for (let i = 0; i < this.GridDataEvent.length; i++) {
      if (i !== index) {
        const otherEvent = this.GridDataEvent[i];
        if (otherEvent.startTime && otherEvent.endTime) {
          const otherStartTime = new Date(otherEvent.startTime).getTime();
          const otherEndTime = new Date(otherEvent.endTime).getTime();

          if (
            (startTime >= otherStartTime && startTime < otherEndTime) ||  // Overlapping start
            (endTime > otherStartTime && endTime <= otherEndTime) ||  // Overlapping end
            (startTime <= otherStartTime && endTime >= otherEndTime)  // Full overlap
          ) {
            event.isOverlapping = true;
            return;
          }
        }
      }
    }
    event.isOverlapping = false;
  });
}
  getPR(){
  
    if(this.servicePlan.serviceDeliveryPlanId != "00000000-0000-0000-0000-000000000000")
      {
        return;
      }
    let url = "api/ClientAgreement/GetClientPRforSDP?";

    let params = new URLSearchParams();
    params.append("ClientId",  this.global.clientId);

    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if(data?.length == 0)
      {
      this.serviceplanImportBO.participantRepresentative = [];
      this.serviceplanImportBO.participantRepresentative.push(new ParticipantRepresentative())
      }
      else{

        this.serviceplanImportBO.participantRepresentative = data.map((item: any) => {
          return {
            ...item, 
            phoneNumber: this.general.converPhoneGoogleLib(item.phoneNumber) 
          };
        });
      }

    
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err);
      }
      else {
        this.toastrService.error(err);
      }

    })

  }
    OutBoundCall(event :any ,StartDate ,EndDate ) {
      console.log(event , StartDate ,EndDate )
    const currentDateTime = new Date();
    const EventStartdate = new Date(StartDate);
    const EventEnddate = new Date(EndDate);

    // Extract business hours (only hr & min)
    const businessStartTime = new Date(this.global.businessStartTime);
    const businessEndTime = new Date(this.global.businessEndTime);
    const startHour = businessStartTime.getHours();
    const startMin = businessStartTime.getMinutes();
    const endHour = businessEndTime.getHours();
    const endMin = businessEndTime.getMinutes();

    // Build today/tomorrow markers
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Build today's business window
    const businessStartToday = new Date(today);
    businessStartToday.setHours(startHour, startMin, 0, 0);

    const businessEndToday = new Date(today);
    if (endHour < startHour)
      businessEndToday.setDate(businessEndToday.getDate() + 1);
    businessEndToday.setHours(endHour, endMin, 0, 0);

    // Build next‐day business start
    const nextDayBusinessStart = new Date(tomorrow);
    nextDayBusinessStart.setHours(startHour, startMin, 0, 0);

    const fifteenMinutes = 15 * 60 * 1000;
    const eventTime = EventStartdate.getTime();
    const currentTime = currentDateTime.getTime();

    const isToday = EventStartdate.toDateString() === today.toDateString();
    const isTomorrow = EventStartdate.toDateString() === tomorrow.toDateString();
    event.noCallMessage = '';
    event.isCheckboxDisabled = false;
    event.getConfirmation = true;
  console.log(today , tomorrow , isToday , isTomorrow , businessStartToday , businessEndToday ,nextDayBusinessStart )
   console.log( this.global.isValidCcxAccessKey ,this.clientConfirmation  , currentTime , eventTime , EventStartdate , currentDateTime )

    if (
      this.global.isValidCcxAccessKey &&
      this.clientConfirmation &&
      (isToday || isTomorrow) 
    ) {
      if( isToday && eventTime < currentTime)
      {
          event.getConfirmation = false;
          event.isCheckboxDisabled = true;
          event.noCallMessage = "Event time is passed";
      } 
      else if( isToday && eventTime <= currentTime +fifteenMinutes)
        {
           event.noCallMessage= "short notice";
           event.getConfirmation = false;
           event.isCheckboxDisabled = true;
          //  document.getElementById("openNoCallModel")?.click();
        }
      // 1st: Today & within business hours (±15min)
      else if (isToday && eventTime < businessStartToday.getTime()+fifteenMinutes) {
        event.noCallMessage = "Outside of business hours";
        event.getConfirmation = false;
        event.isCheckboxDisabled = true;

        // document.getElementById("openNoCallModel")?.click();
      }
     else if (
        isToday &&
        currentTime < businessEndToday.getTime() - fifteenMinutes &&
        eventTime > businessStartToday.getTime() + fifteenMinutes
      ) {
        event.getConfirmation = true;
        // document.getElementById("opencallModel")?.click();

        // 2nd: Today but after business end, before next day's start+15
      } else if (
        isToday || isTomorrow &&
        currentTime > businessEndToday.getTime() - fifteenMinutes &&
        eventTime < nextDayBusinessStart.getTime() + fifteenMinutes
      ) {
        event.noCallMessage = "Outside of business hours"
        event.getConfirmation = false;
        event.isCheckboxDisabled = true;
        // document.getElementById("openNoCallModel")?.click();

        // 3rd: Event is beyond next day's start +15 → allow call
      } 
       else if (eventTime > nextDayBusinessStart.getTime() + fifteenMinutes) {
        event.getConfirmation = true;
      }
       else {
        event.getConfirmation = true;
        //  this.SaveEvents();
       }
    } 
    else {

      event.getConfirmation = true;
      
        }
  }
    Getclientmodelandlanguage() {
    let url = "api/Event/GetEventClientData?";

    let params = new URLSearchParams();
    params.append("clientId", this.global.clientId);
    this.EventService.getDropdown(url + params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            console.log(data, "data===================");
            this.clientConfirmation = data[0].clientConfirmation;
          }
        )
    }
    cfssWorkerBudget(){
      console.log(this.serviceplanImportBO?.fmsBudget?.fmsFee , this.mhcptotal ,this.Goodsgrandtotal )
      
    const fmsFee = this.serviceplanImportBO?.fmsBudget?.fmsFee || 0;
    const mhcpTotal = this.mhcptotal || 0;
    const goodsGrandTotal = this.Goodsgrandtotal || 0;
    this.serviceplanImportBO.cfssWorkerBudget = this.serviceplanImportBO?.fmsBudget?.budgetAmount - fmsFee - mhcpTotal - goodsGrandTotal;
     if(this.AnnualTotal > this.serviceplanImportBO.cfssWorkerBudget)
    {
      this.Budgetwarning = true;
      this.warningAmount = Number(this.AnnualTotal- this.serviceplanImportBO.cfssWorkerBudget).toFixed(2);
    }
    else
      this.Budgetwarning = false;

    }
    apiCareCoordinators: CareCoordinator[] = [];
  getcasemanager() {

  let url = "api/ClientAgreement/GetClientCaseManagerforSDP?";
  let params = new URLSearchParams();
  params.append("ClientId", this.global.clientId);

  this.CommonAPI.GetFunctionwithResponseTypeJson(params, url)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe({
      next: (data: any) => {
        if (!data || data.length === 0) {
          this.apiCareCoordinators = [];
          this.serviceplanImportBO.careCoordinator = [new CareCoordinator()];
        } else {
          this.apiCareCoordinators = data.map((item: any) => ({
            ...item,
            phoneNumber: this.general.converPhoneGoogleLib(item.phoneNumber),
            id:"00000000-0000-0000-0000-000000000000",
          }));

          // Show only first record initially
          this.serviceplanImportBO.careCoordinator = this.apiCareCoordinators;
        }
      },
      error: (err) => {
        this.toastrService.error(err);
      },
    });
    
}
//  changefunction() {
//    console.trace('changefunction called from:'); // This will show the call stack
//     this.changevalue = true;
//  console.log(this.changevalue);
//   }
    changefunction() {
      console.log('changefunction');
    this.changevalue = true;
  }
  //......................................clientvaluechange.....................................
  SDPvaluechange(){
    if (this.changevalue == true) {
      document.getElementById("cancelsdpmodal").click();
    } else {

      this.closeFun();
    }
  }

}